import "./chatSection.css";
import DashboardPanelSwitcher from "../Common/DashboardPanelSwitcher";
import SqlResultDataTable, {
  SqlResultDataTableFullViewModal,
  SqlResultViewSwitcher,
} from "../Common/SqlResultDataTable";
import EmcureModalShell from "../Common/EmcureModalShell/EmcureModalShell";
import {
  EmcureModalChartBody,
  EmcureBubbleChartPlot,
  ChartPdfExportTable,
} from "../Common/EmcureDataCharts";
import {
  IconChevronRight,
  IconChevronLeft,
  IconPlus,
  IconChevronDown,
  IconChevronDownBold,
  IconDownload,
  IconTrash,
  IconLogout,
  IconMessageBubbleWhite,
  QuickBarChart,
  QuickCurrency,
  QuickStar,
  IconSendWhite,
  IconDocumentExcel,
  IconDocumentWord,
  IconDocumentPdf,
  IconExternalExpand,
  IconSqlBracketsWhite,
  IconCheck,
  IconCopy,
  IconThumbUpFilled,
  IconThumbUpOutline,
  IconThumbDownFilled,
  IconThumbDownOutline,
  IconChevronRightSm,
  IconPencilEdit,
  IconSend,
  IconX,
  IconScrollUp,
  IconScrollDown,
  IconSearch,
  IconPauseSquare,
  IconChartPie,
  IconChartBar,
  IconChartLine,
  IconChevronRightXs,
} from "../Common/EmcureReactIcons";
import iconProfile from "../../assets/images/icon_profile.svg";
import React, { useState, useEffect, useRef, useLayoutEffect, useMemo } from "react";
import iconSend from "../../assets/images/icon_send.svg";
import iconChatBot from "../../assets/images/iconChatbot.png";
import emcureLogo from "../../assets/images/emcure_logo.svg";
import { getUserId, getUserName } from "../../utils/userUtils";
import chatService from "../../services/chatService";
import sessionService from "../../services/sessionService";
import feedbackService from "../../services/feedbackService";
import suggestionService from "../../services/suggestionService";
import queryService from "../../services/queryService";
import { getWebSocketUrl } from "../../Configurations/config";
import AutoTyping from "../chatbot/autoTyping";
import MarkdownAutoTyping from "../chatbot/markdownAutoTyping";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { Document, Paragraph, TextRun, Packer, HeadingLevel, AlignmentType, Table, TableRow, TableCell, WidthType, BorderStyle, ImageRun } from "docx";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { useNavigate, useLocation } from "react-router-dom";
import { getMsalInstance } from "../../msalConfig";
import { tokenRefreshService } from "../../services/tokenRefreshService";
import {
  clearUserInfo,
  getAdminAccess,
  getSupervisorAccess,
  getSemanticAdminAccess,
  USER_ACCESS_CHANGED_EVENT,
} from "../../utils/userUtils";
import websocketService from "../../services/websocketService";
import { prepareVisualizationData, transformChartData } from "../../utils/dataTransformers";
import {
  enrichChartsFromRawResults,
  filterDisplayableCharts,
  hasDisplayableCharts,
  isChartPointValid,
  resolveSuggestedChartsFromMessage,
} from "../../utils/chartDataBuilders";
import { getTableColumnSchema } from "../../utils/normalizeTableRows";
import {
  applyBufferedTableLoadMore,
  buildInitialTablePagination,
  buildTableMetaFromSource,
  buildTablePaginationEntry,
  extractRawResultsFromPayload,
  extractTablePaginationSources,
  getLoadMoreBatchSize,
  processLoadMoreResponse,
  parseTableMessageIndex,
  resolveTableFooterState,
  resolveTableLoadOffset,
  TABLE_PAGE_SIZE,
} from "../../utils/tablePaginationUtils";
import { applyTableSortResult } from "../../utils/applyTableSortResult";
import { fetchSortedTableViaExecuteSql } from "../../utils/fetchSortedTableViaExecuteSql";
import { resolveSortRowCount } from "../../utils/sortLimitOptions";
import { resolveExecuteSqlQuery } from "../../utils/resolveExecuteSqlQuery";
import { formatChartAxisDateValue as formatDateValue } from "../../utils/formatChartAxisDate";
import {
  captureChartCardImage,
  fitChartImageToPdf,
} from "../../utils/captureChartCardImage";
import { parseExecuteSqlResponse } from "../../utils/parseExecuteSqlResponse";
import MarkdownRenderer from "../Common/MarkdownRenderer";
import TipsAndUpdatesRoundedIcon from '@mui/icons-material/TipsAndUpdatesRounded';
import QuestionAnswerRoundedIcon from '@mui/icons-material/QuestionAnswerRounded';
import {
  normalizeChartMetricNumber,
  parseChartTooltipNumber,
  resolveChatChartType,
} from "./ChatSectionChartHelpers";
import { getChartTypeOptionsForPointCount } from "../Common/EmcureDataCharts/emcureChartConstants";
import { humanizeColumnLabel } from "../Common/EmcureDataCharts/emcureChartConstants";
import {
  stripUndefinedArtifacts,
  removeMarkdownTable,
  safeText,
  isCurrencyColumn,
  highlightSql,
} from "./chatSectionDisplayUtils";
import { downloadCsv, getCsvExportOptions } from "./chatSectionCsvUtils";

const ACCESS_STORAGE_KEYS = ["hasAdminAccess", "hasSupervisorAccess", "hasSemanticAdminAccess"];

const ChatSection = ({ newSession, setNewSession, activeSessionId, setActiveSessionId, onNewSessionCreated, isSidebarCollapsed, setIsSidebarCollapsed, userName: propUserName }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sessionConversation, setSessionConversation] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [chatLoader, setLoader] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [isBotTyping, setIsBotTyping] = useState(false);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [feedbackState, setFeedbackState] = useState({});
  const [showExportMenu, setShowExportMenu] = useState(false);
  const [openTableExportDropdown, setOpenTableExportDropdown] = useState(null); // msgIndex | 'fullview' | null
  const [exportCsvLoadingKey, setExportCsvLoadingKey] = useState(null); // `${msgIndex}:${export_type}` | 'fullview:...'
  const [openTableSortDropdown, setOpenTableSortDropdown] = useState(null); // `${contextKey}:${column}` | null
  const [tableSortLoadingKey, setTableSortLoadingKey] = useState(null);
  const [tableActiveSortByMsg, setTableActiveSortByMsg] = useState({}); // { [msgIndex]: { columnName, sortOrder } }
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const [showTopQueries, setShowTopQueries] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [wsConnected, setWsConnected] = useState(false);
  const [processingStatus, setProcessingStatus] = useState('');
  const [processingType, setProcessingType] = useState('');
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [feedbackMessageIndex, setFeedbackMessageIndex] = useState(null);
  const [feedbackText, setFeedbackText] = useState('');
  const [topQueries, setTopQueries] = useState([]);
  const [loadingTopQueries, setLoadingTopQueries] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const [suggestionsForMessage, setSuggestionsForMessage] = useState(null); // Track which message has suggestions
  const [tablePagination, setTablePagination] = useState({}); // Track pagination state for each table
  const [hasAdminAccess, setHasAdminAccess] = useState(() => getAdminAccess());
  const [hasSupervisorAccess, setHasSupervisorAccess] = useState(() => getSupervisorAccess());
  const [hasSemanticAdminAccess, setHasSemanticAdminAccess] = useState(() => getSemanticAdminAccess());

  useEffect(() => {
    const refreshAccessFlags = () => {
      setHasAdminAccess(getAdminAccess());
      setHasSupervisorAccess(getSupervisorAccess());
      setHasSemanticAdminAccess(getSemanticAdminAccess());
    };
    const handleStorage = (event) => {
      if (!event.key || ACCESS_STORAGE_KEYS.includes(event.key)) refreshAccessFlags();
    };

    refreshAccessFlags();
    window.addEventListener(USER_ACCESS_CHANGED_EVENT, refreshAccessFlags);
    window.addEventListener("storage", handleStorage);
    return () => {
      window.removeEventListener(USER_ACCESS_CHANGED_EVENT, refreshAccessFlags);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);
  const [loadingPagination, setLoadingPagination] = useState({});
  const sessionConversationRef = useRef(sessionConversation);
  const tablePaginationRef = useRef(tablePagination);
  const loadingPaginationRef = useRef(loadingPagination);
  const chartVizPrefetchInFlightRef = useRef(new Set());

  useEffect(() => {
    sessionConversationRef.current = sessionConversation;
  }, [sessionConversation]);

  useEffect(() => {
    tablePaginationRef.current = tablePagination;
  }, [tablePagination]);

  useEffect(() => {
    loadingPaginationRef.current = loadingPagination;
  }, [loadingPagination]);

  const [isPaginationUpdate, setIsPaginationUpdate] = useState(false); // Track if update is from pagination
  const [sessions, setSessions] = useState([]);
  const [showSessionDropdown, setShowSessionDropdown] = useState(false);
  const [fullViewChart, setFullViewChart] = useState(null);
  const [fullViewTable, setFullViewTable] = useState(null);
  const [fullViewTableLoading, setFullViewTableLoading] = useState(false);
  const [chartTypeOverrides, setChartTypeOverrides] = useState({}); // { 'msg-idx-chart-idx': 'bar'|'pie'|'line' }
  const [openChartTypeDropdown, setOpenChartTypeDropdown] = useState(null); // chartKey or null
  const [tableResultViewModes, setTableResultViewModes] = useState({}); // { msgIndex: 'table' | 'chart' }
  // Close table-export dropdown on click outside
  useEffect(() => {
    if (!openTableExportDropdown) return;
    const handler = (e) => {
      if (!e.target.closest(".table-export-dropdown-wrapper")) {
        setOpenTableExportDropdown(null);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [openTableExportDropdown]);

  useEffect(() => {
    if (!openTableSortDropdown) return;
    const handler = (e) => {
      if (
        !e.target.closest(".table-sort-dropdown-wrapper") &&
        !e.target.closest(".table-sort-dropdown-menu")
      ) {
        setOpenTableSortDropdown(null);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [openTableSortDropdown]);

  const [showScrollUp, setShowScrollUp] = useState(false);
  const [showScrollDown, setShowScrollDown] = useState(false);
  const [queryMode, setQueryMode] = useState('qa'); // 'qa' | 'reasoning'
  const [showQueryModeDropdown, setShowQueryModeDropdown] = useState(false);
  const queryModeDropdownRef = React.useRef(null);

  const [isFirstMessage, setIsFirstMessage] = useState(true);
  const [userName, setUserName] = useState(propUserName || getUserName());

  // NEW: Track multiple concurrent requests
  const [inFlightRequests, setInFlightRequests] = useState({});

  // Pause + inline edit flow (for the latest user message while bot is responding)
  const abortControllerRef = useRef(null);
  const activeRequestIdRef = useRef(null);
  const activeRequestSessionIdRef = useRef(null);
  const activeUserMessageIdRef = useRef(null);
  // Stores sub_queries received via websocket per requestId so they survive inFlightRequests cleanup
  const subQueriesByRequestIdRef = useRef({});
  const [pausedUserMessageId, setPausedUserMessageId] = useState(null);
  const [editingUserMessageId, setEditingUserMessageId] = useState(null);
  const [editingUserMessageIndex, setEditingUserMessageIndex] = useState(null);
  const [editingText, setEditingText] = useState("");
  const [editingOriginalText, setEditingOriginalText] = useState("");
  const [copiedUserMessageId, setCopiedUserMessageId] = useState(null);
  const [hoveredUserMessageId, setHoveredUserMessageId] = useState(null);

  // NEW: Sub-query dropdown state for reasoning mode
  const [showSubQueryDropdown, setShowSubQueryDropdown] = useState({}); // { msgIndex: boolean }

  const getStatusIcon = (type) => {
    const iconMap = {
      'query_processing': '🔍',
      'sql_generation': '⚙️',
      'sql_execution': '💾',
      'data_analysis': '📊',
      'chart_generation': '📈',
      'response_ready': '✨',
      'processing_status': '⚡'
    };
    return iconMap[type] || '⚡';
  };
  const chatSectionRef = useRef(null);
  // If the user scrolls up, we should not force-scroll while streaming responses.
  // We only auto-scroll when the user is already near the bottom.
  const shouldAutoScrollRef = useRef(true);
  const textareaRef = useRef(null);
  const isSubmittingRef = useRef(false);
  const lastQueryRef = useRef(null);
  const lastFetchedSessionRef = useRef(null);
  const currentSessionIdRef = useRef(sessionId);
  const processingWrapperRef = useRef(null);
  const sessionCacheRef = useRef({});

  const uuidv4 = () =>
    "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
      (
        +c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))
      ).toString(16)
    );

  useLayoutEffect(() => {
    setSessionId(uuidv4());
    setIsBotTyping(false);
    setLoader(false);
  }, []);

  useEffect(() => {
    currentSessionIdRef.current = sessionId;
  }, [sessionId]);

  // Cache messages per session so that if the backend has not yet
  // persisted a session (e.g., while the first answer is generating),
  // we can still restore the conversation when the user comes back.
  useEffect(() => {
    if (!currentSessionIdRef.current) return;
    if (!sessionConversation || sessionConversation.length === 0) return;
    sessionCacheRef.current[currentSessionIdRef.current] = sessionConversation;
  }, [sessionConversation]);

  useEffect(() => {
    if (!sessionId) return;

    const statusMessages = {
      'processing_status': 'Processing your request',
      'query_processing': 'Analyzing your query',
      'sql_generation': 'Generating database query',
      'sql_execution': 'Retrieving data from database',
      'data_analysis': 'Processing retrieved data',
      'chart_generation': 'Preparing visualizations',
      'response_ready': 'Finalizing your response',
      'Selecting columns': 'Selecting relevant data columns',
      'Processing': 'Processing your request'
    };

    websocketService.onMessage('chatSection', (data) => {
      const { type, request_id, step, message, status, progress_percent, sub_queries } = data;
      
      // NEW: Handle progress messages with request_id
      if (type === 'progress' && request_id) {
        // Persist sub_queries into ref so they survive inFlightRequests cleanup
        if (sub_queries && sub_queries.length > 0) {
          subQueriesByRequestIdRef.current[request_id] = sub_queries;
        }
        // Update request tracking
        setInFlightRequests(prev => ({
          ...prev,
          [request_id]: {
            step: step || prev[request_id]?.step || 'Processing',
            message: message || prev[request_id]?.message || 'Processing your request',
            status: status || prev[request_id]?.status || 'in_progress',
            progressPercent: progress_percent ?? prev[request_id]?.progressPercent ?? 0,
            subQueries: sub_queries || prev[request_id]?.subQueries || null,
          },
        }));

        // NEW: Update bot typing status with progress
        const displayMessage = message && message !== step 
          ? (statusMessages[message] || message)
          : (statusMessages[step] || step || 'Processing your request');
        setProcessingStatus(`${getStatusIcon(step)} ${displayMessage}`);
        setProcessingType(step || 'processing_status');
        return;
      }

      // NEW: Handle completion with smart cleanup
      if ((type === 'complete' || type === 'error') && request_id) {
        setInFlightRequests(prev => {
          const { [request_id]: _, ...rest } = prev;
          // Only clear status when ALL requests complete
          if (Object.keys(rest).length === 0) {
            setProcessingStatus('');
            setProcessingType('');
            setIsBotTyping(false);
          }
          return rest;
        });
        return;
      }

      // Existing fallback handling for backward compatibility
      switch (data.type) {
        case 'processing_status':
        case 'query_processing':
        case 'sql_generation':
        case 'sql_execution':
        case 'data_analysis':
        case 'chart_generation':
        case 'response_ready':
          const defaultMessage = statusMessages[data.type] || statusMessages['Processing'];
          const displayMessage = data.message && data.message !== data.type 
            ? (statusMessages[data.message] || data.message)
            : defaultMessage;
          setProcessingStatus(`${getStatusIcon(data.type)} ${displayMessage}`);
          setProcessingType(data.type);
          break;
          
        case 'complete':
          setProcessingStatus('');
          setProcessingType('');
          break;
          
        case 'error':
          setProcessingStatus('');
          setProcessingType('');
          break;
          
        default:
          if (data.message) {
            const professionalMessage = statusMessages[data.message] || data.message;
            setProcessingStatus(`${getStatusIcon(data.type)} ${professionalMessage}`);
            setProcessingType(data.type || 'processing_status');
          }
      }
    });

    return () => {
      websocketService.offMessage('chatSection');
      websocketService.disconnect();
    };
  }, [sessionId]);

  // Close chart-type dropdown on click outside
  useEffect(() => {
    if (!openChartTypeDropdown) return;
    const handler = () => setOpenChartTypeDropdown(null);
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [openChartTypeDropdown]);

  // Close query-mode dropdown on click outside
  useEffect(() => {
    if (!showQueryModeDropdown) return;
    const handler = (e) => {
      if (queryModeDropdownRef.current && !queryModeDropdownRef.current.contains(e.target)) {
        setShowQueryModeDropdown(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [showQueryModeDropdown]);

  // NEW: Close sub-query dropdowns on click outside
  useEffect(() => {
    const hasOpenDropdown = Object.values(showSubQueryDropdown).some(Boolean);
    if (!hasOpenDropdown) return;
    
    const handler = (e) => {
      if (!e.target.closest('.sub-query-dropdown-wrapper')) {
        setShowSubQueryDropdown({});
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [showSubQueryDropdown]);

  useEffect(() => {
    const checkConnection = setInterval(() => {
      setWsConnected(websocketService.isConnected());
    }, 5000);

    return () => clearInterval(checkConnection);
  }, []);

  // Only auto-scroll to bottom right after history load (not on table pagination updates).
  const pendingHistoryAutoScrollSessionIdRef = useRef(null);

  // Track scroll position – show ↑ when scrolled down, show ↓ when at top
  useEffect(() => {
    const el = chatSectionRef.current;
    if (!el) return;
    const onScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = el;
      const hasScroll = scrollHeight > clientHeight + 20;
      const nearTop = scrollTop < 60;
      setShowScrollUp(!nearTop && hasScroll);   // scrolled down  → show ↑
      setShowScrollDown(nearTop && hasScroll);  // at top         → show ↓

      // Track whether the user is close enough to the bottom that we can
      // safely auto-scroll as new content streams in.
      const thresholdPx = 120;
      const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);
      shouldAutoScrollRef.current = distanceFromBottom <= thresholdPx;
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // initial check
    return () => el.removeEventListener('scroll', onScroll);
  }, [sessionConversation]);

  useEffect(() => {
    if (!activeSessionId || newSession) {
      lastFetchedSessionRef.current = null;
      setIsLoadingHistory(false);
      return;
    }

    if (activeSessionId === currentSessionIdRef.current) {
      return;
    }

    if (lastFetchedSessionRef.current === activeSessionId) {
      return;
    }

    lastFetchedSessionRef.current = activeSessionId;
    
    // Update currentSessionIdRef immediately to prevent race conditions
    currentSessionIdRef.current = activeSessionId;
    
    // Clear current view immediately so messages from the previously
    // selected session are not shown while the new session is loading.
    setSessionConversation([]);
    setTablePagination({});
    setFeedbackState({});
    setSuggestions([]);
    setSuggestionsForMessage(null);
    setFullViewChart(null);
    setFullViewTable(null);

    // NEW: Clear in-flight requests when switching sessions
    setInFlightRequests({});

    // NEW: Clear sub-query dropdown when switching sessions
    setShowSubQueryDropdown({});

    // Clear chart type overrides so previous session's layout choices don't carry over.
    setChartTypeOverrides({});
    setOpenChartTypeDropdown(null);
    setTableResultViewModes({});

    setIsBotTyping(false);
    setLoader(false);
    setIsLoadingHistory(true);
    pendingHistoryAutoScrollSessionIdRef.current = activeSessionId;

    sessionService
      .getSessionMessages(activeSessionId)
      .then((res) => {
        const { messages } = res || {};

        // If backend has no messages for this session but we have a cached
        // in-memory conversation, use the cache so the page is not blank.
        if (!messages || messages.length === 0) {
          const cached = sessionCacheRef.current[activeSessionId];
          if (cached && cached.length > 0) {
            setSessionConversation(cached);
            setTablePagination(buildInitialTablePagination(cached));
            setSessionId(activeSessionId);
            setIsLoadingHistory(false);
            return;
          }
        }

        // Build mapped messages from history
        const mapped = messages.map((msg, index) => {
          let charts = [];

          const vizData = msg.metadata?.visualization_data || msg.visualization_data;
          const rawResults = vizData?.raw_results || msg.raw_results;
          const suggestedCharts = resolveSuggestedChartsFromMessage(msg, vizData);

          if (suggestedCharts) {
            let filteredCharts = suggestedCharts;
            
            // In reasoning mode, only show line charts
            if (msg.metadata?.intent === 'reasoning_workflow') {
              filteredCharts = suggestedCharts.filter(chart => 
                chart.type === 'line' || chart.chart_type === 'line'
              );
            }
            
            charts = filterDisplayableCharts(
              enrichChartsFromRawResults(rawResults, filteredCharts)
            ).map((chart) => ({
              ...chart,
              ref: React.createRef(),
              title:
                chart.title ||
                `${humanizeColumnLabel(chart.y_column)} by ${humanizeColumnLabel(chart.x_column)}`,
            }));
          }

          const sqlQuery =
            msg.metadata?.final_generated_sql_query ||
            msg.metadata?.visualization_data?.sql ||
            msg.metadata?.sql_query ||
            msg.sql_query ||
            vizData?.sql;
          const showSqlQuery = sqlQuery && sqlQuery !== "General route - no SQL needed";

          let messageBody = msg.content || "";
          if (msg.role !== "user") {
            const answer = vizData?.answer || msg.metadata?.visualization_data?.answer;
            if (answer) {
              messageBody = answer;
            }
          }

          let cleanedBody = messageBody;
          if (rawResults && rawResults.length > 0) {
            cleanedBody = messageBody.replace(/\|[^\n]+\|[\s\S]*?(?=\n\n|\*\*|$)/g, '').trim();
          }
          const { pagination, dataSummary } = extractTablePaginationSources({
            metadata: msg.metadata ?? {},
            visualization_data: vizData ?? msg.visualization_data,
          });
          const tableMeta =
            msg.metadata?.intent === "reasoning_workflow"
              ? null
              : buildTableMetaFromSource({
                  rawResults,
                  pagination,
                  dataSummary,
                });

          return {
            type: msg.role === "user" ? "USER" : "SYSTEM",
            body: cleanedBody ? cleanedBody.replace(/\n/g, "<br/>") : "",
            time: new Date(msg.timestamp).toLocaleString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            }),
            charts,
            rawResults: tableMeta?.displayedResults ?? null,
            rawResultsBuffer: tableMeta?.rawResultsBuffer ?? null,
            sqlQuery: showSqlQuery ? sqlQuery : null,
            totalCount: tableMeta?.totalCount ?? null,
            pagination: tableMeta?.pagination ?? pagination,
            dataSummary: tableMeta?.dataSummary ?? dataSummary,
            showCharts: charts.length > 0,
            hasSuggestedCharts: charts.length > 0,
            chartsVizChecked: true,
            fromHistory: true,
            id: msg.message_id || msg.id || `history-${msg.timestamp}`,
            messageId: msg.message_id || (typeof msg.id === 'number' ? msg.id : null),
            feedback: msg.feedback,
            // NEW: Add sub_queries for reasoning mode
            subQueries: msg.metadata?.sub_queries || msg.sub_queries || null,
            isReasoning: msg.metadata?.intent === 'reasoning_workflow',
            queryType: msg.metadata?.query_type || msg.query_type || (msg.metadata?.intent === 'reasoning_workflow' ? 'reasoning' : 'qa'),
          };
        });

        const initialFeedbackState = {};

        mapped.forEach((msg, index) => {
          if (msg.feedback === "1" || msg.feedback === 1) {
            initialFeedbackState[index] = 'up';
          } else if (msg.feedback === "-1" || msg.feedback === -1) {
            initialFeedbackState[index] = 'down';
          }
        });

        // Replace the conversation with history for this session
        // Don't merge with previous conversation to avoid mixing sessions
        setSessionConversation(mapped);
        setFeedbackState(initialFeedbackState);
        setTablePagination(buildInitialTablePagination(mapped));
        
        // Only update sessionId if it's different to prevent unnecessary re-renders
        if (sessionId !== activeSessionId) {
          setSessionId(activeSessionId);
        }
        setIsLoadingHistory(false);
      })
      .catch(() => {
        setIsLoadingHistory(false);
      });
  }, [activeSessionId, newSession]);

  // When loading an existing session's history, automatically scroll to
  // the latest message so that the user sees the end of the conversation.
  useEffect(() => {
    if (isLoadingHistory) return;
    if (!chatSectionRef.current) return;
    if (!activeSessionId) return;
    if (!sessionConversation || sessionConversation.length === 0) return;

    // Only scroll when we've just finished loading history for this session.
    if (pendingHistoryAutoScrollSessionIdRef.current !== activeSessionId) return;
    pendingHistoryAutoScrollSessionIdRef.current = null;

    const container = chatSectionRef.current;
    container.scrollTop = container.scrollHeight;
  }, [isLoadingHistory, activeSessionId, sessionConversation]);

  useEffect(() => {
    if (newSession) {
      const newSessionId = uuidv4();
      setSessionConversation([]);
      setSessionId(newSessionId);
      setIsFirstMessage(true);
      setIsBotTyping(false);
      setLoader(false);
      isSubmittingRef.current = false;
      lastFetchedSessionRef.current = null;
      setTablePagination({});
      setFeedbackState({});
      setSuggestions([]);
      setSuggestionsForMessage(null);
      setFullViewChart(null);
      setFullViewTable(null);
      
      // NEW: Clear in-flight requests when creating new session
      setInFlightRequests({});
      
      // NEW: Clear sub-query dropdown when creating new session
      setShowSubQueryDropdown({});
      
      // Update currentSessionIdRef to the new session ID
      currentSessionIdRef.current = newSessionId;
    }
  }, [newSession]);

  useEffect(() => {
    if (activeSessionId && !newSession) {
      setIsFirstMessage(false);
      setIsBotTyping(false);
    }
  }, [activeSessionId, newSession]);

  const handleExportPDF = async (ref, title) => {
    if (!ref.current) return;
    try {
      const dataUrl = await captureChartCardImage(ref.current);
      if (!dataUrl) return;

      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "pt",
        format: "a4",
      });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imgProps = pdf.getImageProperties(dataUrl);
      const ratio = Math.min(
        pageWidth / imgProps.width,
        pageHeight / imgProps.height
      );
      pdf.addImage(
        dataUrl,
        "PNG",
        (pageWidth - imgProps.width * ratio) / 2,
        (pageHeight - imgProps.height * ratio) / 2,
        imgProps.width * ratio,
        imgProps.height * ratio
      );
      pdf.save(`${title}.pdf`);
    } catch (err) {
    }
  };

  const formatLargeNumber = (value, isCurrency = true) => {
    const prefix = isCurrency ? '₹' : '';
    const numericValue = typeof value === 'number' ? value : parseFloat(value) || 0;
    return `${prefix}${numericValue.toLocaleString('en-IN')}`;
  };

  // Custom percentage label rendered inside each pie slice
  const renderPiePercentageLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
  }) => {
    if (percent === 0 || percent == null) return null;

    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) / 2;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="#FFFFFF"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={11}
        fontWeight={600}
      >
        {`${(percent * 100).toFixed(1)}%`}
      </text>
    );
  };

  // Custom tooltip for pie charts so we can show the brand/category name
  // as header and the formatted value on the next line (similar to bar chart).
  const PieTooltip = ({ active, payload, yLabel }) => {
    if (!active || !payload || !payload.length) return null;

    const dataPoint = payload[0]?.payload || {};
    const name = safeText(dataPoint.xValue ?? dataPoint.name ?? "");
    let rawValue = dataPoint.yValue ?? payload[0].value;

    // Normalize numeric value
    if (typeof rawValue === "string") {
      const parsed = parseFloat(rawValue.replace(/[₹$€,]/g, "").replace(/,/g, ""));
      if (!Number.isNaN(parsed)) {
        rawValue = parsed;
      }
    }

    const isCurrency = yLabel && isCurrencyColumn(String(yLabel));
    const numeric = typeof rawValue === "number" ? rawValue : Number(rawValue) || 0;
    const formattedNumber = numeric.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const prefix = isCurrency ? "₹" : "";

    return (
      <div
        style={{
          fontSize: "13px",
          backgroundColor: "#FFFFFF",
          borderRadius: "10px",
          padding: "12px 16px",
          border: "1px solid #E5E7EB",
          fontWeight: 600,
          boxShadow:
            "0 10px 15px -3px rgba(15, 23, 42, 0.1), 0 4px 6px -4px rgba(15, 23, 42, 0.1)",
        }}
      >
        <div
          style={{
            color: "#111827",
            fontWeight: 700,
            marginBottom: 6,
            maxWidth: 260,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
          title={name}
        >
          {name}
        </div>
        <div style={{ color: "#111827" }}>
          <span style={{ fontWeight: 700 }}>
            {safeText(yLabel || "Value")}
            {": "}
          </span>
          <span>
            {prefix}
            {formattedNumber}
          </span>
        </div>
      </div>
    );
  };

  /** Bot replies only — keep text verbatim (no trimming/stripping). */
  const safeBotDisplayText = (text) => safeText(text);

  const isReasoningMessage = (msg) =>
    Boolean(msg?.isReasoning) || String(msg?.queryType || "").toLowerCase() === "reasoning";

  /** Q/A and other non-reasoning bot replies: show the data table whenever we have rows (charts may show too). */
  const shouldRenderDataTable = (msg) =>
    Boolean(
      msg?.rawResults &&
        msg.rawResults.length > 0 &&
        !isReasoningMessage(msg)
    );

  const shouldShowMessageCharts = (msg) =>
    (isReasoningMessage(msg)
      ? hasDisplayableCharts(msg?.charts)
      : msg?.showCharts && hasDisplayableCharts(msg?.charts));

  const stripMessageBodyText = (body) =>
    String(body ?? "")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<[^>]+>/g, "")
      .trim();

  const getUserQueryForBotMessage = (msgIndex) => {
    const conv = sessionConversationRef.current;
    for (let i = msgIndex - 1; i >= 0; i--) {
      if (conv[i]?.type === "USER") {
        return stripMessageBodyText(conv[i].body);
      }
    }
    return "";
  };

  const resolveApiMessageId = (apiData = {}) => {
    const candidates = [
      apiData.message_id,
      apiData.messageId,
      apiData.metadata?.message_id,
      apiData.data?.message_id,
    ];
    for (const id of candidates) {
      if (id != null && id !== "") return id;
    }
    return null;
  };

  const canRequestMessageCharts = (msg) =>
    Boolean(
      !isReasoningMessage(msg) &&
      msg?.rawResults?.length > 0 &&
      msg?.sqlQuery &&
      msg?.messageId &&
      !msg?.chartsVizFailed &&
      !hasDisplayableCharts(msg?.charts)
    );

  const shouldAutoFetchMessageCharts = (msg) =>
    Boolean(canRequestMessageCharts(msg) && !msg?.chartsVizChecked);

  const buildDisplayableChartsFromSuggestions = (chartSuggestions, rawResults) => {
    if (!Array.isArray(chartSuggestions) || chartSuggestions.length === 0) return [];

    let filtered = chartSuggestions;
    if (queryMode === "reasoning") {
      const lineOnly = chartSuggestions.filter(
        (chart) => chart.type === "line" || chart.chart_type === "line"
      );
      filtered = lineOnly.length > 0 ? lineOnly : chartSuggestions;
    }

    const newCharts = filtered
      .map((chart) => {
        const transformed = transformChartData(chart);
        if (!transformed) return null;
        return { ...transformed, ref: React.createRef() };
      })
      .filter(Boolean);

    return filterDisplayableCharts(
      enrichChartsFromRawResults(rawResults, newCharts)
    ).map((chart) => ({
      ...chart,
      ref: chart.ref ?? React.createRef(),
      title:
        chart.title ||
        `${humanizeColumnLabel(chart.y_column)} by ${humanizeColumnLabel(chart.x_column)}`,
    }));
  };

  const fetchChartsForMessage = async (message, userQuery) => {
    if (!message?.sqlQuery || !message?.rawResults?.length || !message?.messageId) {
      return [];
    }

    const numericResults = prepareVisualizationData(message.rawResults);
    const visualizationResponse = await chatService.getVisualization(
      userQuery,
      message.sqlQuery,
      numericResults,
      activeSessionId || sessionId,
      message.messageId,
      getUserId()
    );

    const vizPayload =
      visualizationResponse?.visualization_data ||
      visualizationResponse?.metadata?.visualization_data ||
      visualizationResponse;
    const suggestedCharts = resolveSuggestedChartsFromMessage(
      visualizationResponse,
      vizPayload
    );

    if (!suggestedCharts) {
      return [];
    }

    return buildDisplayableChartsFromSuggestions(
      suggestedCharts,
      message.rawResults
    );
  };

  const prefetchVisualizationForMessage = async (msgIndex, messageSnapshot = null) => {
    const message = messageSnapshot ?? sessionConversationRef.current[msgIndex];
    if (!message || !shouldAutoFetchMessageCharts(message)) return;

    const flightKey = String(message.messageId ?? msgIndex);
    if (chartVizPrefetchInFlightRef.current.has(flightKey)) return;
    chartVizPrefetchInFlightRef.current.add(flightKey);

    try {
      const displayableCharts = await fetchChartsForMessage(
        message,
        getUserQueryForBotMessage(msgIndex)
      );
      const hasCharts = displayableCharts.length > 0;

      setSessionConversation((prev) =>
        prev.map((m, i) =>
          i === msgIndex
            ? {
                ...m,
                charts: displayableCharts,
                showCharts: hasCharts,
                hasSuggestedCharts: hasCharts,
                chartsVizFailed: !hasCharts,
                chartsVizChecked: true,
              }
            : m
        )
      );
    } catch {
      setSessionConversation((prev) =>
        prev.map((m, i) =>
          i === msgIndex
            ? {
                ...m,
                chartsVizFailed: true,
                chartsVizChecked: true,
                hasSuggestedCharts: false,
              }
            : m
        )
      );
    } finally {
      chartVizPrefetchInFlightRef.current.delete(flightKey);
    }
  };

  // Run visualize after query when charts are not inline (ref can lag behind setState).
  useEffect(() => {
    sessionConversation.forEach((msg, index) => {
      if (msg?.type !== "SYSTEM" || msg?.fromHistory) return;
      if (!shouldAutoFetchMessageCharts(msg)) return;
      prefetchVisualizationForMessage(index, msg);
    });
  }, [sessionConversation]);

  const renderMessageChartsPanel = (msg, idx) => {
    if (!shouldShowMessageCharts(msg)) return null;

    return (
      <div className="charts-wrapper charts-wrapper-flex">
        {msg.charts.map((chart, cIdx) => {
          const chartKey = `${idx}-${cIdx}`;
          const chartTypeRaw = String(chart.type || chart.chart_type || "").toLowerCase();

          const validData = Array.isArray(chart.data)
            ? chart.data.filter((d) => isChartPointValid(d, chart, chartTypeRaw))
            : [];

          const chartType = resolveChatChartType(
            chart,
            chartTypeOverrides[chartKey],
            validData.length
          );

          if (validData.length === 0) {
            return (
              <div key={cIdx} className="chart-error-container">
                <p className="chart-error-text">No valid data available for this chart</p>
              </div>
            );
          }

          return (
            <div
              key={`chart-${idx}-${cIdx}-${chart.type}`}
              className="chart-item-wrapper-styled"
              ref={chart.ref}
            >
              <div className="chart-header">
                <h3 className="chart-title">{safeText(chart.title) || "Chart"}</h3>
                <div className="chart-header-actions">
                  <div className="chart-type-dropdown-wrapper" style={{ position: "relative" }}>
                    <button
                      className="chart-action-btn chart-type-toggle-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenChartTypeDropdown((prev) =>
                          prev === chartKey ? null : chartKey
                        );
                      }}
                      title="Change chart type"
                    >
                      {chartType === "pie" && <IconChartPie width={14} height={14} />}
                      {chartType === "bar" && <IconChartBar width={14} height={14} />}
                      {chartType === "line" && <IconChartLine width={14} height={14} />}
                      <span style={{ textTransform: "capitalize" }}>{chartType}</span>
                      <IconChevronDownBold width={10} height={10} />
                    </button>
                    {openChartTypeDropdown === chartKey && (
                      <div
                        className="chart-type-dropdown-menu"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {getChartTypeOptionsForPointCount(validData.length).map(
                          ({ type: t, label }) => {
                            const icon =
                              t === "pie" ? (
                                <IconChartPie width={14} height={14} />
                              ) : t === "line" ? (
                                <IconChartLine width={14} height={14} />
                              ) : (
                                <IconChartBar width={14} height={14} />
                              );
                            return (
                              <button
                                key={t}
                                type="button"
                                className={`chart-type-dropdown-item${chartType === t ? " active" : ""}`}
                                onClick={() => {
                                  setChartTypeOverrides((prev) => ({ ...prev, [chartKey]: t }));
                                  setOpenChartTypeDropdown(null);
                                }}
                              >
                                {icon}
                                {label}
                              </button>
                            );
                          }
                        )}
                      </div>
                    )}
                  </div>

                  <button
                    onClick={() => setFullViewChart({ ...chart, _selectedType: chartType })}
                    className="chart-action-btn"
                  >
                    <IconExternalExpand width={14} height={14} />
                    Full View
                  </button>
                  <button
                    onClick={() =>
                      handleExportPDF(chart.ref, chart.title.replace(/\s+/g, "_"))
                    }
                    className="chart-export-btn"
                  >
                    <IconDownload width={14} height={14} />
                    Export PDF
                  </button>
                </div>
              </div>

              <EmcureBubbleChartPlot
                chartType={chartType}
                validData={validData}
                chart={chart}
                cIdx={cIdx}
                gradIdPrefix={`${idx}-${cIdx}`}
                formatDateAxis={formatDateValue}
                parseTooltipNumber={parseChartTooltipNumber}
              />
              <ChartPdfExportTable chart={{ ...chart, data: validData }} />
            </div>
          );
        })}
      </div>
    );
  };

  const parseTooltipMetricValue = parseChartTooltipNumber;

  const handleExportCSV = async ({ msgIndex = null, exportType, messageId, sessionId }) => {
    if (!messageId || !sessionId || !exportType) return;
    const key = `${msgIndex ?? "fullview"}:${exportType}`;
    setExportCsvLoadingKey(key);

    try {
      // Required: use backend export API only.
      const res = await chatService.exportQueryResults({
        message_id: messageId,
        session_id: sessionId,
        export_type: exportType,
      });

      const headers = res?.headers || [];
      const data = res?.data || [];
      if (!Array.isArray(headers) || headers.length === 0) return;

      downloadCsv({
        headers,
        data,
        filename: `table-export-${sessionId}-${messageId}-${exportType}-${Date.now()}.csv`,
      });
    } catch (e) {
      // Avoid crashing the UI with an uncaught promise rejection.
      // (Backend may return 404 if export endpoint isn't deployed yet.)
      console.error("CSV export failed:", e);
    } finally {
      setExportCsvLoadingKey(null);
      setOpenTableExportDropdown(null);
    }
  };

  const buildTableSortProps = (
    contextKey,
    msgIndex,
    messageId,
    sessionId,
    { queryRowCount, loadedCount } = {}
  ) => {
    const openColumn = (() => {
      if (!openTableSortDropdown) return null;
      const prefix = `${contextKey}:`;
      if (String(openTableSortDropdown).startsWith(prefix)) {
        return String(openTableSortDropdown).slice(prefix.length);
      }
      return null;
    })();

    const activeSort =
      msgIndex != null && !Number.isNaN(msgIndex) ? tableActiveSortByMsg[msgIndex] : null;

    const totalRowCount = resolveSortRowCount({ queryRowCount, loadedCount });

    return {
      messageId,
      sessionId,
      queryRowCount,
      loadedCount,
      totalRowCount,
      openDropdownKey: openColumn,
      onToggleSortDropdown: (col) => {
        const key = `${contextKey}:${col}`;
        setOpenTableSortDropdown(openTableSortDropdown === key ? null : key);
      },
      onApplySort: ({ column_name, column_key, sort_order, limit }) =>
        handleTableSort({
          msgIndex,
          messageId,
          sessionId,
          column_name,
          column_key,
          sort_order,
          limit,
        }),
      isSortLoading: (col) => tableSortLoadingKey === `${contextKey}:${col}`,
      activeSort: activeSort
        ? { columnKey: activeSort.columnKey, sortOrder: activeSort.sortOrder }
        : null,
    };
  };

  const handleTableSort = async ({
    msgIndex,
    messageId,
    sessionId,
    column_name,
    column_key,
    sort_order,
    limit,
  }) => {
    if (!messageId || !sessionId || !column_name || !sort_order) return;

    const contextKey = msgIndex ?? "fullview";
    const loadingKey = column_key ?? column_name;
    setTableSortLoadingKey(`${contextKey}:${loadingKey}`);

    try {
      const resolvedMsgIndex =
        msgIndex != null && !Number.isNaN(msgIndex)
          ? msgIndex
          : parseTableMessageIndex(fullViewTable?.tableKey);

      if (resolvedMsgIndex == null || Number.isNaN(resolvedMsgIndex)) return;

      const tableKey = `table-${resolvedMsgIndex}`;
      const msg = sessionConversationRef.current[resolvedMsgIndex];
      const referenceRows = msg?.rawResults;
      const baseSql = msg?.sqlQuery;
      if (!baseSql) return;

      const pag = tablePaginationRef.current[tableKey];
      const { totalCount: sortTotalCount } = resolveTableFooterState({
        rawResults: referenceRows,
        dataSummary: msg?.dataSummary ?? {},
        paginationInfo: msg?.pagination ?? {},
        storedTotalCount: msg?.totalCount ?? pag?.totalCount,
        rawResultsBuffer: msg?.rawResultsBuffer,
      });

      const { response: res, sortedSql: builtSortedSql } = await fetchSortedTableViaExecuteSql({
        baseSql,
        columnName: column_name,
        sortOrder: sort_order,
        userLimit: limit ?? null,
        knownTotalCount: sortTotalCount,
        knownLoadedCount: referenceRows?.length ?? 0,
        sessionId,
        userId: getUserId(),
        referenceRows,
      });

      if (!res?.success && !(res?.data?.length > 0)) return;

      const sortApplied = applyTableSortResult({
        response: res,
        msgIndex: resolvedMsgIndex,
        tableKey,
        referenceRows,
        fullViewReferenceRows:
          fullViewTable?.tableKey === tableKey ? fullViewTable.data : null,
        setRows: setSessionConversation,
        setTablePagination,
        setFullViewTable,
      });

      setTableActiveSortByMsg((prev) => ({
        ...prev,
        [resolvedMsgIndex]: {
          columnKey: loadingKey,
          columnName: column_name,
          sortOrder: sort_order,
          limit: limit ?? null,
          sortedSql:
            sortApplied?.sortedSql ??
            builtSortedSql ??
            res.sorted_sql ??
            res.sortedSql ??
            null,
        },
      }));
    } catch (e) {
      console.error("Table sort failed:", e);
    } finally {
      setTableSortLoadingKey(null);
      setOpenTableSortDropdown(null);
    }
  };

  const handleFullViewTableLoadMore = async () => {
    if (!fullViewTable?.sqlQuery || fullViewTableLoading) return;

    const tableKey = fullViewTable.tableKey;
    const existingRows = fullViewTable.data ?? [];
    const pag = tableKey ? tablePaginationRef.current[tableKey] : null;
    const msgIndex =
      tableKey != null ? Number(String(tableKey).replace("table-", "")) : NaN;
    const msg = Number.isNaN(msgIndex) ? null : sessionConversationRef.current[msgIndex];
    const loadedCount = existingRows.length;
    const requestOffset = resolveTableLoadOffset(pag, loadedCount);
    const { totalCount: resolvedTotal, hasMore: initialHasMore } = resolveTableFooterState({
      rawResults: existingRows,
      dataSummary: msg?.dataSummary ?? {},
      paginationInfo: msg?.pagination ?? {},
      storedTotalCount: fullViewTable.totalCount ?? msg?.totalCount,
      rawResultsBuffer: msg?.rawResultsBuffer,
    });
    const limit = getLoadMoreBatchSize(loadedCount, resolvedTotal, TABLE_PAGE_SIZE);

    if (limit <= 0 || initialHasMore === false) {
      setFullViewTable((prev) => (prev ? { ...prev, hasMore: false } : prev));
      return;
    }

    setFullViewTableLoading(true);
    try {
      const buffered = applyBufferedTableLoadMore({
        existingRows,
        rawResultsBuffer: msg?.rawResultsBuffer,
        limit,
        previousTotalCount: resolvedTotal,
        paginationInfo: msg?.pagination ?? {},
      });
      if (buffered) {
        const footer = resolveTableFooterState({
          rawResults: buffered.merged,
          dataSummary: msg?.dataSummary ?? {},
          paginationInfo: msg?.pagination ?? {},
          storedTotalCount: buffered.totalCount ?? resolvedTotal,
          rawResultsBuffer: msg?.rawResultsBuffer,
        });
        setFullViewTable((prev) =>
          prev
            ? {
                ...prev,
                data: buffered.merged,
                hasMore: footer.hasMore,
                totalCount: footer.totalCount,
              }
            : prev
        );
        if (tableKey) {
          setTablePagination((prev) => ({
            ...prev,
            [tableKey]: {
              offset: buffered.nextOffset,
              loadedCount: buffered.loadedCount,
              totalCount: footer.totalCount,
              hasMore: footer.hasMore,
            },
          }));
          if (!Number.isNaN(msgIndex)) {
            setSessionConversation((prev) => {
              if (!prev[msgIndex]) return prev;
              const updated = [...prev];
              updated[msgIndex] = {
                ...updated[msgIndex],
                rawResults: buffered.merged,
                totalCount: footer.totalCount,
              };
              return updated;
            });
          }
        }
        return;
      }

      const activeSort = !Number.isNaN(msgIndex) ? tableActiveSortByMsg[msgIndex] : null;
      const baseSql = msg?.sqlQuery ?? fullViewTable.sqlQuery;
      const resolvedSql = resolveExecuteSqlQuery(baseSql, activeSort, {
        offset: requestOffset,
        limit,
      });
      const sqlForExecute = resolvedSql?.sql ?? baseSql;
      const executeOffset = resolvedSql?.offset ?? requestOffset;
      const executeLimit = resolvedSql?.limit ?? limit;

      const response = await chatService.executeSql(
        sqlForExecute,
        executeOffset,
        executeLimit,
        activeSessionId || sessionId,
        getUserId()
      );
      const { rows: newRows, pagination, dataSummary, ok } = parseExecuteSqlResponse(
        response,
        existingRows
      );
      if (!ok && (!newRows || newRows.length === 0)) return;

      const result = processLoadMoreResponse({
        existingRows,
        newRows: newRows || [],
        requestOffset,
        limit,
        paginationInfo: pagination,
        dataSummary,
        previousTotalCount: resolvedTotal,
        bufferLength: msg?.rawResultsBuffer?.length ?? 0,
      });

      const footer = resolveTableFooterState({
        rawResults: result.merged,
        dataSummary: msg?.dataSummary ?? dataSummary ?? {},
        paginationInfo: pagination,
        storedTotalCount: result.totalCount ?? resolvedTotal,
        rawResultsBuffer: msg?.rawResultsBuffer,
      });

      setFullViewTable((prev) =>
        prev
          ? {
              ...prev,
              data: result.merged,
              hasMore: footer.hasMore,
              totalCount: footer.totalCount,
            }
          : prev
      );

      if (tableKey) {
        setTablePagination((prev) => ({
          ...prev,
          [tableKey]: {
            offset: result.nextOffset,
            loadedCount: result.loadedCount,
            totalCount: footer.totalCount,
            hasMore: footer.hasMore,
          },
        }));

        const msgIndex = parseTableMessageIndex(tableKey);
        if (!Number.isNaN(msgIndex)) {
          setSessionConversation((prev) => {
            if (!prev[msgIndex]) return prev;
            const updated = [...prev];
            updated[msgIndex] = {
              ...updated[msgIndex],
              rawResults: result.merged,
              totalCount: footer.totalCount,
            };
            return updated;
          });
        }
      }
    } catch (error) {
      console.error("Full view load more failed:", error);
    } finally {
      setFullViewTableLoading(false);
    }
  };

  const handleCopySQL = (sqlQuery, index) => {
    navigator.clipboard.writeText(sqlQuery).then(() => {
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 2000);
    }).catch(err => {
    });
  };

  const handleDownloadExcel = async () => {
    if (sessionConversation.length === 0) {
      return;
    }

    try {
      const workbook = new ExcelJS.Workbook();
      workbook.creator = 'Emcure AI Assistant';
      workbook.created = new Date();
      
      const summarySheet = workbook.addWorksheet('Summary', {
        views: [{ state: 'frozen', xSplit: 0, ySplit: 1 }]
      });
      
      summarySheet.addRow(['Emcure AI Assistant - Chat History']).font = { size: 16, bold: true, color: { argb: 'FF1E293B' } };
      summarySheet.addRow([`Session ID: ${sessionId}`]).font = { size: 10, color: { argb: 'FF666666' } };
      summarySheet.addRow([`Generated: ${new Date().toLocaleString()}`]).font = { size: 10, color: { argb: 'FF666666' } };
      summarySheet.addRow([]);
      
      const headerRow = summarySheet.addRow(['Sender', 'Time', 'Message', 'Has Table', 'Has Charts', 'SQL Query']);
      headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1E293B' } };
      headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
      headerRow.height = 25;
      
      sessionConversation.forEach((msg) => {
        let cleanText = msg.body.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]*>/g, '');
        if (msg.rawResults && msg.rawResults.length > 0) {
          cleanText = cleanText.replace(/\|[^\n]+\|[\s\S]*?(?=\n\n|$)/g, '').trim();
        }
        
        const row = summarySheet.addRow([
          msg.type === "USER" ? userName : "AI Assistant",
          msg.time,
          cleanText,
          msg.rawResults && msg.rawResults.length > 0 ? "✓ Yes" : "No",
          msg.charts && msg.charts.length > 0 ? `${msg.charts.length} chart(s)` : "No",
          msg.sqlQuery ? "✓ Yes" : "No"
        ]);
        
        row.alignment = { vertical: 'top', wrapText: true };
        if (msg.type === "USER") {
          row.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEFF6FF' } };
        }
      });
      
      summarySheet.columns = [
        { width: 15 },
        { width: 12 },
        { width: 60 },
        { width: 12 },
        { width: 15 },
        { width: 12 }
      ];

      let tableCount = 0;
      for (let idx = 0; idx < sessionConversation.length; idx++) {
        const msg = sessionConversation[idx];
        if (msg.rawResults && msg.rawResults.length > 0) {
          tableCount++;
          const sheetName = `Table ${tableCount}`;
          const tableSheet = workbook.addWorksheet(sheetName, {
            views: [{ state: 'frozen', xSplit: 0, ySplit: 5 }]
          });
          
          const titleRow = tableSheet.addRow([`Query Result ${tableCount}`]);
          titleRow.font = { size: 14, bold: true, color: { argb: 'FF1E293B' } };
          titleRow.height = 25;
          
          tableSheet.addRow([`From: ${msg.type === "USER" ? userName : "AI Assistant"} at ${msg.time}`]).font = { size: 10, color: { argb: 'FF666666' } };
          tableSheet.addRow([`Rows: ${msg.rawResults.length} | Columns: ${Object.keys(msg.rawResults[0]).length}`]).font = { size: 10, color: { argb: 'FF666666' } };
          tableSheet.addRow([]);
          
          const columns = Object.keys(msg.rawResults[0]);
          const headerRow = tableSheet.addRow(columns.map(col => col.replace(/_/g, ' ').toUpperCase()));
          headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 };
          headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1E293B' } };
          headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
          headerRow.height = 30;
          
          msg.rawResults.forEach((row, rowIdx) => {
            const dataRow = tableSheet.addRow(columns.map(col => {
              const value = row[col];
              if (value === null || value === undefined) return '';
              if (typeof value === 'number') {
                return Number.isInteger(value) ? value : Number(value.toFixed(2));
              }
              return value;
            }));
            
            if (rowIdx % 2 === 0) {
              dataRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF5F7FA' } };
            }
            
            dataRow.eachCell((cell, colNumber) => {
              const isNumeric = typeof cell.value === 'number';
              cell.alignment = { 
                vertical: 'middle', 
                horizontal: isNumeric ? 'right' : 'left' 
              };
              if (isNumeric) {
                cell.font = { bold: true, color: { argb: 'FF1E40AF' } };
              }
              cell.border = {
                top: { style: 'thin', color: { argb: 'FFE5E7EB' } },
                bottom: { style: 'thin', color: { argb: 'FFE5E7EB' } }
              };
            });
          });
          
          tableSheet.columns = columns.map((col) => {
            const maxLength = Math.max(
              col.length,
              ...msg.rawResults.map(row => String(row[col] || '').length)
            );
            return { width: Math.min(Math.max(maxLength + 2, 12), 35) };
          });
          
          if (msg.charts && msg.charts.length > 0) {
            let currentRow = tableSheet.rowCount + 2;
            
            for (let chartIdx = 0; chartIdx < msg.charts.length; chartIdx++) {
              const chart = msg.charts[chartIdx];
              if (chart.ref?.current) {
                try {
                  const chartImage = await captureChartCardImage(chart.ref.current);
                  if (!chartImage) continue;

                  const imageId = workbook.addImage({
                    base64: chartImage,
                    extension: 'png',
                  });
                  
                  tableSheet.addImage(imageId, {
                    tl: { col: 0, row: currentRow },
                    ext: { width: 600, height: 350 }
                  });
                  
                  currentRow += 20;
                } catch (err) {
                }
              }
            }
          }
        }
      }

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `chat-history-${sessionId}-${Date.now()}.xlsx`);
      setShowExportMenu(false);
    } catch (error) {
      
      try {
      const wb = XLSX.utils.book_new();
      
      const chatData = [];
      chatData.push(["Emcure AI Assistant - Chat History"]);
      chatData.push([`Session ID: ${sessionId}`]);
      chatData.push([`Generated: ${new Date().toLocaleString()}`]);
      chatData.push([]);
      chatData.push(["Sender", "Time", "Message", "SQL Query", "Has Table", "Has Charts"]);

      sessionConversation.forEach((msg) => {
        let cleanText = msg.body.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]*>/g, '');
        
        if (msg.rawResults && msg.rawResults.length > 0) {
          cleanText = cleanText.replace(/\|[^\n]+\|[\s\S]*?(?=\n\n|$)/g, '').trim();
        }
        
        chatData.push([
          msg.type === "USER" ? userName : "AI Assistant",
          msg.time,
          cleanText,
          msg.sqlQuery || "",
          msg.rawResults && msg.rawResults.length > 0 ? "Yes" : "No",
          msg.charts && msg.charts.length > 0 ? `${msg.charts.length} chart(s)` : "No"
        ]);
      });

      const chatWs = XLSX.utils.aoa_to_sheet(chatData);
      chatWs['!cols'] = [
        { wch: 15 },
        { wch: 10 },
        { wch: 50 },
        { wch: 40 },
        { wch: 12 },
        { wch: 15 }
      ];
      XLSX.utils.book_append_sheet(wb, chatWs, "Chat History");

      let tableCount = 0;
      for (let idx = 0; idx < sessionConversation.length; idx++) {
        const msg = sessionConversation[idx];
        if (msg.rawResults && msg.rawResults.length > 0) {
          tableCount++;
          const tableData = [];
          
          tableData.push([`Query Result ${tableCount}`]);
          tableData.push([`From: ${msg.type === "USER" ? userName : "AI Assistant"} at ${msg.time}`]);
          tableData.push([`Rows: ${msg.rawResults.length} | Columns: ${Object.keys(msg.rawResults[0]).length}`]);
          tableData.push([]);
          
          const columns = Object.keys(msg.rawResults[0]);
          tableData.push(columns.map(col => col.replace(/_/g, ' ').toUpperCase()));
          
          msg.rawResults.forEach(row => {
            tableData.push(columns.map(col => {
              const value = row[col];
              if (value === null || value === undefined) return '';
              if (typeof value === 'number') {
                return Number.isInteger(value) ? value : Number(value.toFixed(2));
              }
              return value;
            }));
          });
          
          if (msg.charts && msg.charts.length > 0) {
            tableData.push([]);
            tableData.push(['Charts:']);
            
            for (let chartIdx = 0; chartIdx < msg.charts.length; chartIdx++) {
              const chart = msg.charts[chartIdx];
              if (chart.ref && chart.ref.current) {
                try {
                  tableData.push([chart.title || `Chart ${chartIdx + 1}`]);
                  tableData.push(['[Chart image - see image below or export as PDF/Word for full visualization]']);
                  tableData.push([]);
                } catch (err) {
                }
              }
            }
          }
          
          const tableWs = XLSX.utils.aoa_to_sheet(tableData);
          
          tableWs['!cols'] = columns.map((col) => {
            const maxLength = Math.max(
              col.length,
              ...msg.rawResults.map(row => String(row[col] || '').length)
            );
            return { wch: Math.min(Math.max(maxLength + 2, 12), 30) };
          });
          
          const headerRowIndex = 4;
          const range = XLSX.utils.decode_range(tableWs['!ref']);
          
          for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ r: headerRowIndex, c: col });
            if (!tableWs[cellAddress]) continue;
            
            tableWs[cellAddress].s = {
              font: { bold: true, color: { rgb: "FFFFFF" } },
              fill: { fgColor: { rgb: "1E293B" } },
              alignment: { horizontal: "center", vertical: "center" }
            };
          }
          
          for (let row = headerRowIndex + 1; row <= range.e.r; row++) {
            for (let col = range.s.c; col <= range.e.c; col++) {
              const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
              if (!tableWs[cellAddress]) continue;
              
              const isEvenRow = (row - headerRowIndex) % 2 === 0;
              tableWs[cellAddress].s = {
                fill: { fgColor: { rgb: isEvenRow ? "FFFFFF" : "F5F7FA" } },
                alignment: { 
                  horizontal: typeof tableWs[cellAddress].v === 'number' ? "right" : "left",
                  vertical: "center" 
                },
                font: { 
                  bold: typeof tableWs[cellAddress].v === 'number',
                  color: { rgb: typeof tableWs[cellAddress].v === 'number' ? "1E40AF" : "000000" }
                }
              };
            }
          }
          
          const sheetName = `Table ${tableCount}`.substring(0, 31);
          XLSX.utils.book_append_sheet(wb, tableWs, sheetName);
        }
      }

      const chartsInfo = [];
      chartsInfo.push(["Charts Information"]);
      chartsInfo.push([]);
      chartsInfo.push(["Message #", "Time", "Chart Title", "Chart Type", "Note"]);
      
      let chartCount = 0;
      sessionConversation.forEach((msg, idx) => {
        if (msg.charts && msg.charts.length > 0) {
          msg.charts.forEach((chart) => {
            chartCount++;
            chartsInfo.push([
              idx + 1,
              msg.time,
              chart.title || `Chart ${chartCount}`,
              chart.type || 'Unknown',
              "Chart images are available in PDF/Word exports"
            ]);
          });
        }
      });

      if (chartCount > 0) {
        const chartsWs = XLSX.utils.aoa_to_sheet(chartsInfo);
        chartsWs['!cols'] = [
          { wch: 12 },
          { wch: 10 },
          { wch: 40 },
          { wch: 12 },
          { wch: 45 }
        ];
        XLSX.utils.book_append_sheet(wb, chartsWs, "Charts Info");
      }

      const sqlQueries = [];
      sqlQueries.push(["SQL Queries"]);
      sqlQueries.push([]);
      sqlQueries.push(["Message #", "Time", "SQL Query"]);
      
      let sqlCount = 0;
      sessionConversation.forEach((msg, idx) => {
        if (msg.sqlQuery) {
          sqlCount++;
          sqlQueries.push([
            idx + 1,
            msg.time,
            msg.sqlQuery
          ]);
        }
      });

      if (sqlCount > 0) {
        const sqlWs = XLSX.utils.aoa_to_sheet(sqlQueries);
        sqlWs['!cols'] = [
          { wch: 12 },
          { wch: 10 },
          { wch: 80 }
        ];
        XLSX.utils.book_append_sheet(wb, sqlWs, "SQL Queries");
      }
      
        XLSX.writeFile(wb, `chat-history-${sessionId}-${Date.now()}.xlsx`);
        setShowExportMenu(false);
      } catch (fallbackError) {
      }
    }
  };

  const handleDownloadPDF = async () => {
    if (sessionConversation.length === 0) {
      return;
    }

    try {
      const pdf = new jsPDF();
      let yPosition = 20;
      const pageHeight = pdf.internal.pageSize.height;
      const margin = 20;
      const maxWidth = 170;

      pdf.setFontSize(18);
      pdf.setTextColor(30, 41, 59);
      pdf.text("Emcure AI Assistant - Chat History", margin, yPosition);
      yPosition += 10;

      pdf.setFontSize(10);
      pdf.setTextColor(100, 100, 100);
      pdf.text(`Session ID: ${sessionId}`, margin, yPosition);
      yPosition += 6;
      pdf.text(`Generated: ${new Date().toLocaleString()}`, margin, yPosition);
      yPosition += 15;

      for (let idx = 0; idx < sessionConversation.length; idx++) {
        const msg = sessionConversation[idx];
        
        if (yPosition > pageHeight - 40) {
          pdf.addPage();
          yPosition = 20;
        }

        pdf.setFontSize(11);
        pdf.setTextColor(30, 64, 175);
        const sender = msg.type === "USER" ? userName : "AI Assistant";
        pdf.text(`${sender} - ${msg.time}`, margin, yPosition);
        yPosition += 7;

        pdf.setFontSize(10);
        pdf.setTextColor(0, 0, 0);
        let cleanText = msg.body.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]*>/g, '');
        
        if (msg.rawResults && msg.rawResults.length > 0) {
          cleanText = cleanText.replace(/\|[^\n]+\|[\s\S]*?(?=\n\n|$)/g, '').trim();
        }
        
        if (cleanText && cleanText.length > 0) {
          const lines = pdf.splitTextToSize(cleanText, maxWidth);
          
          lines.forEach(line => {
            if (yPosition > pageHeight - 20) {
              pdf.addPage();
              yPosition = 20;
            }
            pdf.text(line, margin, yPosition);
            yPosition += 5;
          });
        }

        if (msg.rawResults && msg.rawResults.length > 0) {
          yPosition += 5;
          if (yPosition > pageHeight - 60) {
            pdf.addPage();
            yPosition = 20;
          }

          pdf.setFontSize(9);
          pdf.setTextColor(30, 41, 59);
          pdf.text("Data Table:", margin, yPosition);
          yPosition += 5;

          const columns = Object.keys(msg.rawResults[0]);
          const columnHeaders = columns.map(col => col.replace(/_/g, ' ').toUpperCase());
          const tableData = msg.rawResults.map(row => columns.map(col => {
            const value = row[col];
            if (value === null || value === undefined) return '';
            if (typeof value === 'number') {
              return Number.isInteger(value) ? value.toLocaleString() : value.toFixed(2);
            }
            return String(value);
          }));

          try {
            autoTable(pdf, {
              startY: yPosition,
              head: [columnHeaders],
              body: tableData,
              margin: { left: margin, right: margin },
              styles: { 
                fontSize: 7, 
                cellPadding: 2,
                lineColor: [220, 220, 220],
                lineWidth: 0.5,
                overflow: 'linebreak',
                cellWidth: 'auto',
              },
              headStyles: { 
                fillColor: [30, 41, 59],
                textColor: [255, 255, 255],
                fontStyle: 'bold',
                halign: 'center',
                fontSize: 8,
                cellPadding: 3,
              },
              bodyStyles: {
                textColor: [50, 50, 50],
              },
              alternateRowStyles: { 
                fillColor: [245, 247, 250] 
              },
              columnStyles: columns.reduce((acc, col, idx) => {
                const isNumeric = msg.rawResults.some(row => typeof row[col] === 'number');
                if (isNumeric) {
                  acc[idx] = { halign: 'right', fontStyle: 'bold', textColor: [30, 64, 175] };
                } else {
                  acc[idx] = { halign: 'left' };
                }
                return acc;
              }, {}),
              theme: 'grid',
              tableWidth: 'auto',
            });
            
            yPosition = (pdf.lastAutoTable?.finalY || yPosition) + 10;
          } catch (err) {
            
            pdf.setFontSize(8);
            pdf.setTextColor(0, 0, 0);
            const tableText = `Table with ${msg.rawResults.length} rows and ${columns.length} columns (Error: ${err.message})`;
            pdf.text(tableText, margin, yPosition);
            yPosition += 5;
          }
        }

        if (msg.charts && msg.charts.length > 0) {
          const maxChartWidth = maxWidth;
          const maxChartHeight = 220;

          for (let chartIdx = 0; chartIdx < msg.charts.length; chartIdx++) {
            const chart = msg.charts[chartIdx];
            if (!chart.ref?.current) continue;
            try {
              yPosition += 5;
              if (yPosition > pageHeight - maxChartHeight - 20) {
                pdf.addPage();
                yPosition = 20;
              }

              const chartImage = await captureChartCardImage(chart.ref.current);
              if (!chartImage) continue;

              const img = new Image();
              img.src = chartImage;
              await new Promise((resolve) => {
                img.onload = resolve;
                img.onerror = resolve;
              });

              const { width: imgWidth, height: imgHeight } = fitChartImageToPdf(
                img.width || 1,
                img.height || 1,
                maxChartWidth,
                maxChartHeight
              );

              if (yPosition + imgHeight > pageHeight - 20) {
                pdf.addPage();
                yPosition = 20;
              }

              pdf.addImage(chartImage, "PNG", margin, yPosition, imgWidth, imgHeight);
              yPosition += imgHeight + 10;
            } catch {
              // skip chart if capture fails
            }
          }
        }

        if (msg.sqlQuery) {
          yPosition += 3;
          if (yPosition > pageHeight - 30) {
            pdf.addPage();
            yPosition = 20;
          }
          pdf.setFontSize(9);
          pdf.setTextColor(100, 100, 100);
          pdf.text("SQL Query:", margin, yPosition);
          yPosition += 5;
          
          const sqlLines = pdf.splitTextToSize(msg.sqlQuery, maxWidth);
          sqlLines.forEach(line => {
            if (yPosition > pageHeight - 20) {
              pdf.addPage();
              yPosition = 20;
            }
            pdf.text(line, margin, yPosition);
            yPosition += 4;
          });
        }

        yPosition += 8;

        if (idx < sessionConversation.length - 1) {
          pdf.setDrawColor(200, 200, 200);
          pdf.line(margin, yPosition, margin + maxWidth, yPosition);
          yPosition += 8;
        }
      }

      pdf.save(`chat-history-${sessionId}-${Date.now()}.pdf`);
      setShowExportMenu(false);
    } catch (error) {
    }
  };

  const handleDownloadDOCX = async () => {
    if (sessionConversation.length === 0) {
      return;
    }

    try {
      const children = [];

      children.push(
        new Paragraph({
          text: "Emcure AI Assistant - Chat History",
          heading: HeadingLevel.HEADING_1,
          alignment: AlignmentType.CENTER,
          spacing: { after: 400 },
        })
      );

      children.push(
        new Paragraph({
          children: [
            new TextRun({
              text: `Session ID: ${sessionId}`,
              size: 20,
              color: "666666",
            }),
          ],
          spacing: { after: 200 },
        })
      );

      children.push(
        new Paragraph({
          children: [
            new TextRun({
              text: `Generated: ${new Date().toLocaleString()}`,
              size: 20,
              color: "666666",
            }),
          ],
          spacing: { after: 400 },
        })
      );

      for (let idx = 0; idx < sessionConversation.length; idx++) {
        const msg = sessionConversation[idx];
        children.push(
          new Paragraph({
            children: [
              new TextRun({
                text: msg.type === "USER" ? userName : "AI Assistant",
                bold: true,
                size: 24,
                color: msg.type === "USER" ? "1E40AF" : "B60004",
              }),
              new TextRun({
                text: ` - ${msg.time}`,
                size: 20,
                color: "999999",
              }),
            ],
            spacing: { before: 300, after: 100 },
          })
        );

        let cleanText = msg.body.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]*>/g, '');
        
        if (msg.rawResults && msg.rawResults.length > 0) {
          cleanText = cleanText.replace(/\|[^\n]+\|[\s\S]*?(?=\n\n|$)/g, '').trim();
        }
        
        if (cleanText && cleanText.length > 0) {
          children.push(
            new Paragraph({
              children: [
                new TextRun({
                  text: cleanText,
                  size: 22,
                }),
              ],
              spacing: { after: 200 },
            })
          );
        }

        if (msg.rawResults && msg.rawResults.length > 0) {
          children.push(
            new Paragraph({
              children: [
                new TextRun({
                  text: "Data Table:",
                  bold: true,
                  size: 20,
                  color: "1E293B",
                }),
              ],
              spacing: { before: 200, after: 100 },
            })
          );

          const columns = Object.keys(msg.rawResults[0]);
          const tableRows = [];

          tableRows.push(
            new TableRow({
              children: columns.map(col => 
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: col.replace(/_/g, ' ').toUpperCase(),
                          bold: true,
                          size: 18,
                          color: "FFFFFF",
                        }),
                      ],
                    }),
                  ],
                  shading: {
                    fill: "1E293B",
                  },
                })
              ),
            })
          );

          msg.rawResults.forEach(row => {
            tableRows.push(
              new TableRow({
                children: columns.map(col =>
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: String(row[col] || ''),
                            size: 18,
                          }),
                        ],
                      }),
                    ],
                  })
                ),
              })
            );
          });

          children.push(
            new Table({
              rows: tableRows,
              width: {
                size: 100,
                type: WidthType.PERCENTAGE,
              },
            })
          );

          children.push(
            new Paragraph({
              text: "",
              spacing: { after: 200 },
            })
          );
        }

        if (msg.charts && msg.charts.length > 0) {
          children.push(
            new Paragraph({
              children: [
                new TextRun({
                  text: "Charts:",
                  bold: true,
                  size: 20,
                  color: "1E40AF",
                }),
              ],
              spacing: { before: 200, after: 100 },
            })
          );

          for (let chartIdx = 0; chartIdx < msg.charts.length; chartIdx++) {
            const chart = msg.charts[chartIdx];
            if (chart.ref?.current) {
              try {
                const chartImage = await captureChartCardImage(chart.ref.current);
                if (!chartImage) continue;

                const base64Data = chartImage.split(',')[1];
                const imageBuffer = Uint8Array.from(atob(base64Data), c => c.charCodeAt(0));

                children.push(
                  new Paragraph({
                    children: [
                      new ImageRun({
                        data: imageBuffer,
                        transformation: {
                          width: 600,
                          height: 350,
                        },
                      }),
                    ],
                    spacing: { before: 50, after: 200 },
                    alignment: AlignmentType.CENTER,
                  })
                );
              } catch (err) {
                
                children.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: `Chart: ${chart.title || 'Visualization'} (Image conversion failed)`,
                        size: 18,
                        color: "666666",
                        italics: true,
                      }),
                    ],
                    spacing: { before: 50, after: 100 },
                  })
                );
              }
            }
          }
        }

        if (msg.sqlQuery) {
          children.push(
            new Paragraph({
              children: [
                new TextRun({
                  text: "SQL Query:",
                  bold: true,
                  size: 20,
                }),
              ],
              spacing: { before: 100, after: 100 },
            })
          );

          children.push(
            new Paragraph({
              children: [
                new TextRun({
                  text: msg.sqlQuery,
                  size: 20,
                  font: "Courier New",
                  color: "333333",
                }),
              ],
              spacing: { after: 200 },
            })
          );
        }

        if (idx < sessionConversation.length - 1) {
          children.push(
            new Paragraph({
              text: "─".repeat(50),
              spacing: { before: 200, after: 200 },
            })
          );
        }
      }

      const doc = new Document({
        sections: [
          {
            properties: {},
            children: children,
          },
        ],
      });

      const blob = await Packer.toBlob(doc);
      saveAs(blob, `chat-history-${sessionId}-${Date.now()}.docx`);
    } catch (error) {
    }
  };

  const handleFeedback = async (msgIndex, feedbackType) => {
    if (feedbackType === 'down') {
      setFeedbackMessageIndex(msgIndex);
      setShowFeedbackModal(true);
      setFeedbackText('');
    } else if (feedbackType === 'up') {
      const newState = feedbackState[msgIndex] === 'up' ? null : 'up';
      
      setFeedbackState(prev => ({
        ...prev,
        [msgIndex]: newState
      }));

      if (newState === 'up') {
        try {
          const message = sessionConversation[msgIndex];
          const messageId = message?.messageId;
          
          if (!messageId || typeof messageId !== 'number') {
            return;
          }
          
          await feedbackService.submitUpvote(sessionId, messageId);
        } catch (error) {
          
          setFeedbackState(prev => ({
            ...prev,
            [msgIndex]: null
          }));
        }
      }
    } else {
      setFeedbackState(prev => ({
        ...prev,
        [msgIndex]: null
      }));
    }
  };

  const handleSubmitFeedback = async () => {
    if (!feedbackText.trim()) {
      return;
    }

    try {
      const message = sessionConversation[feedbackMessageIndex];
      const messageId = message?.messageId;

      if (!messageId || typeof messageId !== 'number') {
        setShowFeedbackModal(false);
        setFeedbackMessageIndex(null);
        setFeedbackText('');
        return;
      }

      await feedbackService.submitDownvote(sessionId, messageId, feedbackText);

      setFeedbackState(prev => ({
        ...prev,
        [feedbackMessageIndex]: 'down'
      }));

      setShowFeedbackModal(false);
      setFeedbackMessageIndex(null);
      setFeedbackText('');
    } catch (error) {
      
      setShowFeedbackModal(false);
      setFeedbackMessageIndex(null);
      setFeedbackText('');
    }
  };

  const fetchSuggestions = async (userQuery, sqlQuery, response, sessionId) => {
    setLoadingSuggestions(true);
    setSuggestions([]);
    
    try {
      const conversationHistory = sessionConversation
        .map(msg => `${msg.type === 'USER' ? 'User' : 'Assistant'}: ${msg.body.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]*>/g, '')}`)
        .join('\n');

      const suggestionResponse = await suggestionService.getSuggestions(
        userQuery,
        sqlQuery || '',
        response,
        sessionId,
        getUserId()
      );
      
      if (suggestionResponse && suggestionResponse.suggestions) {
        setSuggestions(suggestionResponse.suggestions);
      }
    } catch (error) {
      setSuggestions([]);
    } finally {
      setLoadingSuggestions(false);
    }
  };

  useEffect(() => {
    const handleSessionsUpdated = (event) => {
      const { sessions: updatedSessions } = event.detail || {};
      if (updatedSessions) {
        setSessions(updatedSessions);
      }
    };

    window.addEventListener('sessionsUpdated', handleSessionsUpdated);

    return () => {
      window.removeEventListener('sessionsUpdated', handleSessionsUpdated);
    };
  }, []);

  useEffect(() => {
    const fetchTopQueries = async () => {
      setLoadingTopQueries(true);
      try {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const analysisDate = `${year}-${month}-${day}`;
        
        const response = await queryService.getTopQueries(10, analysisDate);
        if (response.success && response.queries) {
          const queries = response.queries.map(q => q.query_text);
          setTopQueries(queries);
        }
      } catch (error) {
        
        setTopQueries([
          "Show me top 10 sales data",
          "Show me the total budget for last year",
          "Show me the top 10 HQs by achievement percentage",
          "Show me call average for June",
          "Coverage data by month",
          "Total sales by region"
        ]);
      } finally {
        setLoadingTopQueries(false);
      }
    };

    fetchTopQueries();
  }, []);

  const handleQuerySelect = (query) => {
    // Set input value with typing animation
    let index = 0;
    const typeQuery = () => {
      if (index < query.length) {
        setInputValue(query.substring(0, index + 1));
        index++;
        setTimeout(typeQuery, 30); // 30ms delay between characters for smooth typing
      }
    };
    
    // Start typing animation
    typeQuery();
    
    // Close top queries dropdown
    setShowTopQueries(false);
    
    // Focus textarea after a short delay to ensure it's rendered
    setTimeout(() => {
      if (textareaRef.current) {
        textareaRef.current.focus();
        // Move cursor to end of text
        textareaRef.current.setSelectionRange(query.length, query.length);
      }
    }, 50);
  };

  const handleLogout = async () => {
    try {
      const msalInstance = getMsalInstance();
      
      tokenRefreshService.stopAutoRefresh();
      
      clearUserInfo();
      
      localStorage.removeItem("appToken");
      localStorage.removeItem("databricksToken");
      localStorage.removeItem("tokenExpiry");
      
      await msalInstance.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    } catch (error) {
      clearUserInfo();
      localStorage.clear();
      navigate("/");
    }
  };

  const handleDeleteSession = async () => {
    if (!activeSessionId) {
      setShowDeleteConfirm(false);
      return;
    }

    try {
      const deletedSessionId = activeSessionId;
      
      await sessionService.deleteSession(deletedSessionId);
      
      setSessionConversation([]);
      
      // NEW: Clear in-flight requests when deleting session
      setInFlightRequests({});
      
      // NEW: Clear sub-query dropdown when deleting session
      setShowSubQueryDropdown({});
      
      setShowDeleteConfirm(false);
      
      const userId = getUserId();

      const response = await sessionService.getUserSessions(userId);
      const remainingSessions = response.sessions || [];
      
      if (remainingSessions.length > 0) {
        const firstSession = remainingSessions[0];
        setActiveSessionId(firstSession.session_id);
        setNewSession(false);
      } else {
        setActiveSessionId(null);
        setNewSession(true);
      }
      
      window.dispatchEvent(new CustomEvent('sessionDeleted', { 
        detail: { 
          sessionId: deletedSessionId,
          hasRemainingSessions: remainingSessions.length > 0,
          firstSessionId: remainingSessions.length > 0 ? remainingSessions[0].session_id : null
        } 
      }));
    } catch (error) {
      setShowDeleteConfirm(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showExportMenu && !event.target.closest('.export-dropdown')) {
        setShowExportMenu(false);
      }
      if (showSessionDropdown && !event.target.closest('.session-dropdown')) {
        setShowSessionDropdown(false);
      }
      if (showQueryModeDropdown && queryModeDropdownRef.current && !queryModeDropdownRef.current.contains(event.target)) {
        setShowQueryModeDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showExportMenu, showSessionDropdown]);

  const handleTablePagination = async (msgIndex, direction, sqlQueryFromProp) => {
    const msg = sessionConversationRef.current[msgIndex];
    const sqlQuery = sqlQueryFromProp || msg?.sqlQuery;
    if (direction === "prev" || !sqlQuery) return;

    const tableKey = `table-${msgIndex}`;
    if (loadingPaginationRef.current[tableKey]) return;

    const pag = tablePaginationRef.current[tableKey];
    const existingRows = msg?.rawResults || [];
    const loadedCount = existingRows.length;
    const requestOffset = resolveTableLoadOffset(pag, loadedCount);
    const { totalCount, hasMore: initialHasMore } = resolveTableFooterState({
      rawResults: existingRows,
      dataSummary: msg?.dataSummary ?? {},
      paginationInfo: msg?.pagination ?? {},
      storedTotalCount: msg?.totalCount ?? pag?.totalCount,
      rawResultsBuffer: msg?.rawResultsBuffer,
    });
    const limit = getLoadMoreBatchSize(loadedCount, totalCount, TABLE_PAGE_SIZE);

    if (limit <= 0 || initialHasMore === false) {
      setTablePagination((prev) => ({
        ...prev,
        [tableKey]: { ...prev[tableKey], hasMore: false },
      }));
      return;
    }

    setLoadingPagination((prev) => ({ ...prev, [tableKey]: true }));
    setIsPaginationUpdate(true);

    const applyLoadMoreResult = (result, paginationInfo = msg?.pagination ?? {}) => {
      const { totalCount: resolvedTotalCount, hasMore: resolvedHasMore } =
        resolveTableFooterState({
          rawResults: result.merged,
          dataSummary: msg?.dataSummary ?? {},
          paginationInfo,
          storedTotalCount: result.totalCount ?? totalCount,
          rawResultsBuffer: msg?.rawResultsBuffer,
        });

      if (result.appendedCount === 0 && result.merged.length === existingRows.length) {
        setTablePagination((prev) => ({
          ...prev,
          [tableKey]: {
            ...prev[tableKey],
            hasMore: resolvedHasMore,
            offset: result.nextOffset,
            loadedCount: result.loadedCount,
            totalCount: resolvedTotalCount,
          },
        }));
        return;
      }

      setTablePagination((prev) => ({
        ...prev,
        [tableKey]: {
          offset: result.nextOffset,
          loadedCount: result.loadedCount,
          totalCount: resolvedTotalCount,
          hasMore: resolvedHasMore,
        },
      }));

      setSessionConversation((prev) => {
        if (!prev[msgIndex]) return prev;
        const updated = [...prev];
        updated[msgIndex] = {
          ...updated[msgIndex],
          rawResults: result.merged,
          totalCount: resolvedTotalCount,
          pagination: paginationInfo,
        };
        return updated;
      });

      setFullViewTable((fv) =>
        fv?.tableKey === tableKey
          ? {
              ...fv,
              data: result.merged,
              totalCount: resolvedTotalCount,
              hasMore: resolvedHasMore,
            }
          : fv
      );
    };

    try {
      const buffered = applyBufferedTableLoadMore({
        existingRows,
        rawResultsBuffer: msg?.rawResultsBuffer,
        limit,
        previousTotalCount: totalCount,
        paginationInfo: msg?.pagination ?? {},
      });
      if (buffered) {
        applyLoadMoreResult(buffered, msg?.pagination ?? {});
        return;
      }

      const activeSort = tableActiveSortByMsg[msgIndex];
      const resolvedSql = resolveExecuteSqlQuery(sqlQuery, activeSort, {
        offset: requestOffset,
        limit,
      });
      const sqlForExecute = resolvedSql?.sql ?? sqlQuery;
      const executeOffset = resolvedSql?.offset ?? requestOffset;
      const executeLimit = resolvedSql?.limit ?? limit;

      const response = await chatService.executeSql(
        sqlForExecute,
        executeOffset,
        executeLimit,
        activeSessionId || sessionId,
        getUserId()
      );

      const { rows: newData, pagination: paginationInfo, dataSummary, ok } =
        parseExecuteSqlResponse(response, existingRows);

      if (!ok && (!newData || newData.length === 0)) {
        const { hasMore: stillHasMore } = resolveTableFooterState({
          rawResults: existingRows,
          dataSummary: msg?.dataSummary ?? {},
          paginationInfo,
          storedTotalCount: totalCount,
          rawResultsBuffer: msg?.rawResultsBuffer,
        });
        setTablePagination((prev) => ({
          ...prev,
          [tableKey]: { ...prev[tableKey], hasMore: stillHasMore },
        }));
        return;
      }

      const result = processLoadMoreResponse({
        existingRows,
        newRows: newData || [],
        requestOffset,
        limit,
        paginationInfo,
        dataSummary,
        previousTotalCount: totalCount,
        bufferLength: msg?.rawResultsBuffer?.length ?? 0,
      });

      applyLoadMoreResult(result, paginationInfo);
    } catch (error) {
      console.error("Load more table rows failed:", error);
    } finally {
      setLoadingPagination((prev) => ({ ...prev, [tableKey]: false }));
      setTimeout(() => setIsPaginationUpdate(false), 100);
    }
  };

  const renderDataTable = (rawResults, msgIndex, sqlQuery) => {
    if (!rawResults || rawResults.length === 0) return null;

    const columns = getTableColumnSchema(rawResults);
    const tableKey = `table-${msgIndex}`;
    const pag = tablePagination[tableKey];
    const msgData = sessionConversation?.[msgIndex];
    const isLoading = loadingPagination[tableKey] || false;
    const { loadedCount, totalCount, hasMore, loadMoreCount } = resolveTableFooterState({
      rawResults,
      dataSummary: msgData?.dataSummary ?? {},
      paginationInfo: msgData?.pagination ?? {},
      storedTotalCount: msgData?.totalCount ?? pag?.totalCount,
      rawResultsBuffer: msgData?.rawResultsBuffer,
    });
    const hasCharts = hasDisplayableCharts(msgData?.charts);
    const showChartSwitch = Boolean(msgData?.hasSuggestedCharts && hasCharts);
    const chartsReady = shouldShowMessageCharts(msgData);
    const viewMode =
      showChartSwitch && (tableResultViewModes[msgIndex] ?? "table") === "chart"
        ? "chart"
        : "table";

    const handleViewModeChange = (mode) => {
      if (mode === "table") {
        setTableResultViewModes((prev) => ({ ...prev, [msgIndex]: "table" }));
        return;
      }
      if (!showChartSwitch || !chartsReady) return;

      setSessionConversation((prev) =>
        prev.map((m, i) => (i === msgIndex ? { ...m, showCharts: true } : m))
      );
      setTableResultViewModes((prev) => ({ ...prev, [msgIndex]: "chart" }));
    };

    const tableEl = (
      <SqlResultDataTable
        variant="chat"
        embedInPanel
        rawResults={rawResults}
        formatScalarForDisplay={safeText}
        chat={{
          sqlQuery,
          messageId: sessionConversation?.[msgIndex]?.messageId,
          sessionId: activeSessionId || sessionId,
          loadedCount,
          totalCount,
          hasMore,
          isLoadingMore: isLoading,
          loadMoreCount,
          onOpenFullView: () =>
            setFullViewTable({
              data: rawResults,
              columns,
              sqlQuery,
              hasMore,
              totalCount,
              tableKey,
              messageId: sessionConversation?.[msgIndex]?.messageId || null,
              sessionId: activeSessionId || sessionId,
            }),
          onLoadMore: () => handleTablePagination(msgIndex, "next", sqlQuery),
          getCsvExportOptions,
          onPickExportOption: (exportType) =>
            handleExportCSV({
              msgIndex,
              exportType,
              messageId: sessionConversation?.[msgIndex]?.messageId,
              sessionId: activeSessionId || sessionId,
            }),
          activeExportDropdown: openTableExportDropdown,
          exportDropdownKey: msgIndex,
          onToggleExportDropdown: () => {
            setOpenTableExportDropdown(openTableExportDropdown === msgIndex ? null : msgIndex);
          },
          isExportOptionLoading: (exportType) => exportCsvLoadingKey === `${msgIndex}:${exportType}`,
          sort: buildTableSortProps(
            msgIndex,
            msgIndex,
            sessionConversation?.[msgIndex]?.messageId,
            activeSessionId || sessionId,
            { queryRowCount: totalCount, loadedCount }
          ),
        }}
      />
    );

    const chartEl = chartsReady ? renderMessageChartsPanel(msgData, msgIndex) : null;

    return (
      <SqlResultViewSwitcher
        viewMode={viewMode}
        onViewModeChange={handleViewModeChange}
        showChartSwitch={showChartSwitch}
        tableContent={tableEl}
        chartContent={chartEl}
      />
    );
  };

  const handleSendMessage = async () => {
    const query = inputValue.trim();
    if (!query || isBotTyping || chatLoader || isSubmittingRef.current) return;

    if (lastQueryRef.current === query) {
      return;
    }

    // NEW: Generate unique request ID
    const requestId = crypto.randomUUID();

    isSubmittingRef.current = true;
    lastQueryRef.current = query;

    // Clear any previous paused/editing/hover state when sending a fresh message
    setPausedUserMessageId(null);
    setEditingUserMessageId(null);
    setEditingText("");
    setEditingOriginalText("");
    setHoveredUserMessageId(null);
    
    // NEW: Track request in state
    setInFlightRequests(prev => ({
      ...prev,
      [requestId]: {
        step: 'sent',
        message: query,
        status: 'in_progress',
        progressPercent: 0,
      },
    }));
    
    setIsBotTyping(true);
    setLoader(true);
    setInputValue(""); // Clear input immediately
    setNewSession(false);

    // Capture the session id for this specific request so that
    // responses don't get mixed across sessions if the user switches
    // sessions while the request is in-flight.
    const requestSessionId = currentSessionIdRef.current || sessionId;

    const userMessage = {
      type: "USER",
      body: query,
      time: new Date().toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      }),
      id: Date.now() + Math.random(), // Unique ID
    };

    // Track current request so we can pause/abort it.
    activeRequestIdRef.current = requestId;
    activeRequestSessionIdRef.current = requestSessionId;
    activeUserMessageIdRef.current = userMessage.id;
    abortControllerRef.current?.abort?.();
    abortControllerRef.current = new AbortController();

    setSessionConversation((prev) => {
      const newConversation = [...prev, userMessage];
      
      // Scroll to user message after a short delay to ensure DOM is updated
      setTimeout(() => {
        if (chatSectionRef.current) {
          // Scroll to the bottom to show the user message
          chatSectionRef.current.scrollTop = chatSectionRef.current.scrollHeight;
        }
      }, 50);
      
      return newConversation;
    });

    // For the first message in a brand-new session, immediately notify the
    // parent (LandingPage) so that the Sidebar can show the new session
    // right away, even if the user navigates to another session while the
    // response is still being generated.
    if (isFirstMessage && onNewSessionCreated) {
      setIsFirstMessage(false);
      onNewSessionCreated(requestSessionId, query);
      
      // Update active session to ensure we're tracking the correct session
      setActiveSessionId(requestSessionId);
    } else if (!isFirstMessage && requestSessionId) {
      // For existing sessions, notify sidebar to move this session to the top
      window.dispatchEvent(new CustomEvent('sessionActivity', { 
        detail: { 
          sessionId: requestSessionId
        } 
      }));
    }

    try {
      const userId = getUserId();

      if (!websocketService.isConnected() && requestSessionId) {
        const wsUrl = getWebSocketUrl(requestSessionId);
        
        if (wsUrl) {
          try {
            websocketService.connect(wsUrl, requestSessionId);
            
            let attempts = 0;
            const maxAttempts = 10; // 2 seconds total (10 * 200ms)
            while (!websocketService.isConnected() && attempts < maxAttempts) {
              await new Promise(resolve => setTimeout(resolve, 200));
              attempts++;
            }
            
            const connected = websocketService.isConnected();
            setWsConnected(connected);
            
            if (!connected) {
            }
          } catch (error) {
            setWsConnected(false);
            
          }
        }
      }
      
      if (websocketService.isConnected()) {
        const sent = websocketService.sendQuery(requestSessionId, query, userId, requestId);
        if (sent) {
          setProcessingStatus('Sending query...');
        }
      }

      // Ensure tokens are valid (and store-token has been called) before hitting the query API
      if (!tokenRefreshService.isTokenValid()) {
        await tokenRefreshService.refreshTokens();
      }
      
      const options = {
        query_mode: queryMode
      };

      const response = await chatService.sendQuery(
        query,
        requestSessionId,
        userId,
        options,
        requestId,
        abortControllerRef.current?.signal || null
      );

      setLoader(false);
      setProcessingStatus('');

      const apiData = response;
      let messageText = "";
      if (apiData.answer && apiData.answer !== "undefined" && apiData.answer !== "null") {
        messageText = apiData.answer;
      } else if (apiData.response && apiData.response !== "undefined" && apiData.response !== "null") {
        messageText = apiData.response;
      } else {
        messageText = "No textual response";
      }
      messageText = stripUndefinedArtifacts(String(messageText));
      if (!messageText) {
        messageText = "No textual response";
      }

      // Build charts: prefer inline visualization_data from API (same as history)
      // so charts show on first load; fall back to getVisualization() only when missing.
      let chartData = [];
      const vizData = apiData.metadata?.visualization_data || apiData.visualization_data;
      const rawResults = vizData?.raw_results || apiData.raw_results;
      const suggestedCharts = resolveSuggestedChartsFromMessage(apiData, vizData);

      if (suggestedCharts) {
        let filteredCharts = suggestedCharts;
        
        // In reasoning mode, only show line charts
        if (queryMode === 'reasoning') {
          filteredCharts = suggestedCharts.filter(chart => 
            chart.type === 'line' || chart.chart_type === 'line'
          );
        }
        
        chartData = filterDisplayableCharts(
          enrichChartsFromRawResults(rawResults, filteredCharts)
        ).map((chart) => ({
          ...chart,
          ref: React.createRef(),
          title:
            chart.title ||
            `${humanizeColumnLabel(chart.y_column)} by ${humanizeColumnLabel(chart.x_column)}`,
        }));
      }

      const sqlQuery = 
        apiData.final_generated_sql_query || 
        apiData.metadata?.visualization_data?.sql ||
        apiData.visualization_data?.sql ||
        apiData.sql;
      const showSqlQuery = sqlQuery && sqlQuery !== "General route - no SQL needed";

      const allResults = extractRawResultsFromPayload(apiData);
      const { pagination, dataSummary } = extractTablePaginationSources(apiData);
      const tableMeta = buildTableMetaFromSource({
        rawResults: queryMode === "reasoning" ? [] : allResults,
        pagination,
        dataSummary,
      });

      const botMessage = {
        type: "SYSTEM",
        body: messageText ? messageText.replace(/\n/g, "<br/>") : "No response",
        time: new Date().toLocaleString('en-IN', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        }),
        charts: chartData,
        rawResults: queryMode === "reasoning" ? null : tableMeta.displayedResults,
        rawResultsBuffer: queryMode === "reasoning" ? null : tableMeta.rawResultsBuffer,
        sqlQuery: showSqlQuery ? sqlQuery : null,
        totalCount: tableMeta.totalCount,
        pagination: tableMeta.pagination,
        dataSummary: tableMeta.dataSummary,
        showCharts: chartData.length > 0,
        hasSuggestedCharts: chartData.length > 0,
        chartsVizChecked: chartData.length > 0,
        fromHistory: false,
        id: resolveApiMessageId(apiData) || Date.now() + Math.random(),
        messageId: resolveApiMessageId(apiData),
        // NEW: Add sub_queries for reasoning mode
        subQueries: apiData.metadata?.sub_queries || apiData.sub_queries || subQueriesByRequestIdRef.current[requestId] || inFlightRequests[requestId]?.subQueries || null,
        isReasoning: apiData.metadata?.intent === 'reasoning_workflow' || queryMode === 'reasoning',
        queryType: apiData.query_type || (queryMode === 'reasoning' ? 'reasoning' : 'qa'),
      };
      
      // Track if this was a new session that just got its first response
      const wasNewSession = !isFirstMessage && sessionConversation.filter(m => m.type === 'SYSTEM').length === 0;
      let prefetchChartMsgIndex = null;

      setSessionConversation((prev) => {
        // Guard 1: avoid adding the same assistant message more than once
        if (
          botMessage.messageId &&
          prev.some(
            (m) =>
              m.type === "SYSTEM" &&
              m.messageId &&
              m.messageId === botMessage.messageId
          )
        ) {
          return prev;
        }

        // Guard 2: if there's no messageId (or backend returns null),
        // still avoid obvious duplicates by comparing with last SYSTEM message.
        // Only block if the last SYSTEM message was added very recently (within 2s)
        // to avoid blocking legitimate new responses that happen to have similar content.
        const lastSystem = [...prev].reverse().find((m) => m.type === "SYSTEM");
        if (
          lastSystem &&
          !botMessage.messageId &&
          lastSystem.body === botMessage.body &&
          lastSystem.sqlQuery === botMessage.sqlQuery &&
          lastSystem.id === botMessage.id
        ) {
          return prev;
        }

        // If the user has switched to a different session while this
        // response was in-flight, don't mix messages: update only the
        // cache for that original session and leave the visible
        // conversation unchanged.
        if (currentSessionIdRef.current !== requestSessionId) {
          const existing = sessionCacheRef.current[requestSessionId] || [];
          sessionCacheRef.current[requestSessionId] = [...existing, botMessage];
          return prev;
        }

        const newConversation = [...prev, botMessage];
        sessionConversationRef.current = newConversation;
        prefetchChartMsgIndex = newConversation.length - 1;
        setSuggestionsForMessage(newConversation.length - 1);
        
        if (tableMeta.displayedResults?.length > 0 && queryMode !== "reasoning") {
          const tableKey = `table-${newConversation.length - 1}`;
          setTablePagination((prevPag) => ({
            ...prevPag,
            [tableKey]: buildTablePaginationEntry(tableMeta),
          }));
        }
        
        return newConversation;
      });

      if (
        prefetchChartMsgIndex != null &&
        currentSessionIdRef.current === requestSessionId &&
        shouldAutoFetchMessageCharts(botMessage)
      ) {
        prefetchVisualizationForMessage(prefetchChartMsgIndex, botMessage);
      }
      
      // NEW: For reasoning mode, clear bot typing immediately since we don't use typing animation
      if (apiData.metadata?.intent === 'reasoning_workflow') {
        setIsBotTyping(false);
      }
      // Clean up stored sub_queries for this request
      delete subQueriesByRequestIdRef.current[requestId];
      // NEW: Clean up the completed request from in-flight tracking
      setInFlightRequests(prev => {
        const { [requestId]: _, ...rest } = prev;
        // Only clear status when ALL requests complete
        if (Object.keys(rest).length === 0) {
          setProcessingStatus('');
          setProcessingType('');
          setIsBotTyping(false);
        }
        return rest;
      });
      
      // If this was a new session that just received its first response,
      // notify sidebar to refresh the session list from backend now that
      // the session has been persisted
      if (wasNewSession && currentSessionIdRef.current === requestSessionId) {
        window.dispatchEvent(new CustomEvent('sessionPersisted', { 
          detail: { 
            sessionId: requestSessionId
          } 
        }));
      }

      const suggestionsPromise = currentSessionIdRef.current === requestSessionId
        ? fetchSuggestions(query, sqlQuery, messageText, requestSessionId)
        : Promise.resolve();

      await suggestionsPromise;

    } catch (err) {
      const isAbort =
        err?.name === 'CanceledError' ||
        err?.code === 'ERR_CANCELED' ||
        err?.message?.toLowerCase?.().includes?.('canceled') ||
        err?.message?.toLowerCase?.().includes?.('aborted');

      setLoader(false);
      setIsBotTyping(false);
      setProcessingStatus('');
      
      // NEW: Clean up the failed request from in-flight tracking
      setInFlightRequests(prev => {
        const { [requestId]: _, ...rest } = prev;
        // Only clear status when ALL requests complete
        if (Object.keys(rest).length === 0) {
          setProcessingStatus('');
          setProcessingType('');
          setIsBotTyping(false);
        }
        return rest;
      });

      // If user paused, don't append an error bubble.
      if (isAbort) {
        setPausedUserMessageId(activeUserMessageIdRef.current);
        return;
      }
      
      const errorMessage = err.response?.data?.message || 
                          err.message || 
                          "Failed to send message. Please try again.";
      
      const errorBotMessage = {
        type: "SYSTEM",
        body: `❌ Error: ${errorMessage}`,
        time: new Date().toLocaleString('en-IN', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        }),
        id: Date.now() + Math.random(),
        isError: true,
      };
      
      setSessionConversation((prev) => [...prev, errorBotMessage]);
    } finally {
      setTimeout(() => {
        isSubmittingRef.current = false;
        lastQueryRef.current = null;
      }, 1000);
    }
  };

  const handlePauseResponse = () => {
    // Only pause if there's an active request
    if (!abortControllerRef.current || !activeRequestIdRef.current) return;

    try {
      abortControllerRef.current.abort();
    } catch (_) {
      // no-op
    }

    const requestId = activeRequestIdRef.current;
    const userMsgId = activeUserMessageIdRef.current;
    setPausedUserMessageId(userMsgId);
    setLoader(false);
    setIsBotTyping(false);
    setProcessingStatus('');

    // Clean up in-flight tracking for this request
    setInFlightRequests(prev => {
      const { [requestId]: __, ...rest } = prev;
      if (Object.keys(rest).length === 0) {
        setProcessingStatus('');
        setProcessingType('');
        setIsBotTyping(false);
      }
      return rest;
    });
  };

  const handleCopyUserMessage = async (msg) => {
    try {
      await navigator.clipboard.writeText(String(msg?.body || ''));
      setCopiedUserMessageId(msg.id);
      setTimeout(() => setCopiedUserMessageId(null), 1200);
    } catch (_) {
      // ignore clipboard failures
    }
  };

  const handleStartEditUserMessage = (msg) => {
    setEditingUserMessageId(msg.id);
    // Store index so we can replace the associated bot response (truncate after this turn)
    const idx = sessionConversation.findIndex((m) => m?.id === msg.id);
    setEditingUserMessageIndex(idx >= 0 ? idx : null);
    setEditingText(String(msg.body || ''));
    setEditingOriginalText(String(msg.body || ''));
  };

  const handleCancelEditUserMessage = () => {
    // Revert text back to original and exit edit mode
    setSessionConversation(prev =>
      prev.map(m => (m.id === editingUserMessageId ? { ...m, body: editingOriginalText } : m))
    );
    setEditingUserMessageId(null);
    setEditingUserMessageIndex(null);
    setEditingText("");
    setEditingOriginalText("");
  };

  const handleSendEditedUserMessage = async () => {
    const edited = editingText.trim();
    if (!edited) return;

    const userMessageId = editingUserMessageId;
    const userMessageIndex = editingUserMessageIndex;
    const requestSessionId = activeRequestSessionIdRef.current || currentSessionIdRef.current || sessionId;

    // Update the user bubble text and remove the old assistant response(s) for that turn,
    // so regenerating doesn't look like a "second" user+bot pair.
    setSessionConversation((prev) => {
      const idx = typeof userMessageIndex === 'number' && userMessageIndex >= 0
        ? userMessageIndex
        : prev.findIndex((m) => m?.id === userMessageId);

      if (idx < 0) {
        // Fallback: just update text
        return prev.map((m) => (m.id === userMessageId ? { ...m, body: edited } : m));
      }

      const updated = prev.map((m) => (m.id === userMessageId ? { ...m, body: edited } : m));
      // Truncate everything after this user message; we'll append the new bot response.
      return updated.slice(0, idx + 1);
    });

    // Exit edit mode before requesting
    setEditingUserMessageId(null);
    setEditingUserMessageIndex(null);
    setEditingText("");
    setEditingOriginalText("");

    // Start a fresh request using the edited message (regenerate bot response)
    const requestId = crypto.randomUUID();
    activeRequestIdRef.current = requestId;
    activeRequestSessionIdRef.current = requestSessionId;
    activeUserMessageIdRef.current = userMessageId;
    setPausedUserMessageId(null);

    abortControllerRef.current?.abort?.();
    abortControllerRef.current = new AbortController();

    setInFlightRequests(prev => ({
      ...prev,
      [requestId]: {
        step: 'sent',
        message: edited,
        status: 'in_progress',
        progressPercent: 0,
      },
    }));

    setIsBotTyping(true);
    setLoader(true);
    setNewSession(false);

    try {
      const userId = getUserId();

      // Ensure tokens are valid before hitting the query API
      if (!tokenRefreshService.isTokenValid()) {
        await tokenRefreshService.refreshTokens();
      }

      const options = { query_mode: queryMode };
      const response = await chatService.sendQuery(
        edited,
        requestSessionId,
        userId,
        options,
        requestId,
        abortControllerRef.current?.signal || null
      );

      setLoader(false);
      setProcessingStatus('');

      const apiData = response;
      let messageText = "";
      if (apiData.answer && apiData.answer !== "undefined" && apiData.answer !== "null") {
        messageText = apiData.answer;
      } else if (apiData.response && apiData.response !== "undefined" && apiData.response !== "null") {
        messageText = apiData.response;
      } else {
        messageText = "No textual response";
      }
      messageText = stripUndefinedArtifacts(String(messageText));
      if (!messageText) messageText = "No textual response";

      // Build charts (same logic as normal send)
      let chartData = [];
      const vizData = apiData.metadata?.visualization_data || apiData.visualization_data;
      const rawResults = vizData?.raw_results || apiData.raw_results;
      const suggestedCharts = resolveSuggestedChartsFromMessage(apiData, vizData);

      if (suggestedCharts) {
        let filteredCharts = suggestedCharts;
        if (queryMode === 'reasoning') {
          filteredCharts = suggestedCharts.filter(chart =>
            chart.type === 'line' || chart.chart_type === 'line'
          );
        }
        chartData = filterDisplayableCharts(
          enrichChartsFromRawResults(rawResults, filteredCharts)
        ).map((chart) => ({
          ...chart,
          ref: React.createRef(),
          title:
            chart.title ||
            `${humanizeColumnLabel(chart.y_column)} by ${humanizeColumnLabel(chart.x_column)}`,
        }));
      }

      const sqlQuery =
        apiData.final_generated_sql_query ||
        apiData.metadata?.visualization_data?.sql ||
        apiData.visualization_data?.sql ||
        apiData.sql;
      const showSqlQuery = sqlQuery && sqlQuery !== "General route - no SQL needed";

      const allResults = extractRawResultsFromPayload(apiData);
      const { pagination, dataSummary } = extractTablePaginationSources(apiData);
      const tableMeta = buildTableMetaFromSource({
        rawResults: queryMode === "reasoning" ? [] : allResults,
        pagination,
        dataSummary,
      });

      const botMessage = {
        type: "SYSTEM",
        body: messageText ? messageText.replace(/\n/g, "<br/>") : "No response",
        time: new Date().toLocaleString('en-IN', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        }),
        charts: chartData,
        rawResults: queryMode === "reasoning" ? null : tableMeta.displayedResults,
        rawResultsBuffer: queryMode === "reasoning" ? null : tableMeta.rawResultsBuffer,
        sqlQuery: showSqlQuery ? sqlQuery : null,
        totalCount: tableMeta.totalCount,
        pagination: tableMeta.pagination,
        dataSummary: tableMeta.dataSummary,
        showCharts: chartData.length > 0,
        hasSuggestedCharts: chartData.length > 0,
        chartsVizChecked: chartData.length > 0,
        fromHistory: false,
        id: resolveApiMessageId(apiData) || Date.now() + Math.random(),
        messageId: resolveApiMessageId(apiData),
        subQueries: apiData.metadata?.sub_queries || apiData.sub_queries || subQueriesByRequestIdRef.current[requestId] || inFlightRequests[requestId]?.subQueries || null,
        isReasoning: apiData.metadata?.intent === 'reasoning_workflow' || queryMode === 'reasoning',
        queryType: apiData.query_type || (queryMode === 'reasoning' ? 'reasoning' : 'qa'),
      };

      let prefetchChartMsgIndex = null;

      setSessionConversation((prev) => {
        if (
          botMessage.messageId &&
          prev.some((m) => m.type === "SYSTEM" && m.messageId && m.messageId === botMessage.messageId)
        ) {
          return prev;
        }
        const lastSystem = [...prev].reverse().find((m) => m.type === "SYSTEM");
        if (
          lastSystem &&
          !botMessage.messageId &&
          lastSystem.body === botMessage.body &&
          lastSystem.sqlQuery === botMessage.sqlQuery &&
          lastSystem.id === botMessage.id
        ) {
          return prev;
        }
        if (currentSessionIdRef.current !== requestSessionId) {
          const existing = sessionCacheRef.current[requestSessionId] || [];
          sessionCacheRef.current[requestSessionId] = [...existing, botMessage];
          return prev;
        }
        const newConversation = [...prev, botMessage];
        sessionConversationRef.current = newConversation;
        prefetchChartMsgIndex = newConversation.length - 1;
        setSuggestionsForMessage(newConversation.length - 1);

        if (tableMeta.displayedResults?.length > 0 && queryMode !== "reasoning") {
          const tableKey = `table-${newConversation.length - 1}`;
          setTablePagination((prevPag) => ({
            ...prevPag,
            [tableKey]: buildTablePaginationEntry(tableMeta),
          }));
        }

        return newConversation;
      });

      if (
        prefetchChartMsgIndex != null &&
        currentSessionIdRef.current === requestSessionId &&
        shouldAutoFetchMessageCharts(botMessage)
      ) {
        prefetchVisualizationForMessage(prefetchChartMsgIndex, botMessage);
      }

      if (apiData.metadata?.intent === 'reasoning_workflow') {
        setIsBotTyping(false);
      }
      // Clean up stored sub_queries for this request
      delete subQueriesByRequestIdRef.current[requestId];

      setInFlightRequests(prev => {
        const { [requestId]: _, ...rest } = prev;
        if (Object.keys(rest).length === 0) {
          setProcessingStatus('');
          setProcessingType('');
          setIsBotTyping(false);
        }
        return rest;
      });

      const suggestionsPromise = currentSessionIdRef.current === requestSessionId
        ? fetchSuggestions(edited, sqlQuery, messageText, requestSessionId)
        : Promise.resolve();

      await suggestionsPromise;
    } catch (err) {
      const isAbort =
        err?.name === 'CanceledError' ||
        err?.code === 'ERR_CANCELED' ||
        err?.message?.toLowerCase?.().includes?.('canceled') ||
        err?.message?.toLowerCase?.().includes?.('aborted');

      setLoader(false);
      setIsBotTyping(false);
      setProcessingStatus('');

      setInFlightRequests(prev => {
        const { [requestId]: _, ...rest } = prev;
        if (Object.keys(rest).length === 0) {
          setProcessingStatus('');
          setProcessingType('');
          setIsBotTyping(false);
        }
        return rest;
      });

      if (isAbort) {
        setPausedUserMessageId(userMessageId);
        return;
      }

      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "Failed to send message. Please try again.";

      const errorBotMessage = {
        type: "SYSTEM",
        body: `❌ Error: ${errorMessage}`,
        time: new Date().toLocaleString('en-IN', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
        id: Date.now() + Math.random(),
        isError: true,
      };

      setSessionConversation((prev) => [...prev, errorBotMessage]);
    }
  };

  const isUserMessageResponseCompleted = (userMsgIndex) => {
    // A user message is considered "completed" if there's a SYSTEM message after it
    // before the next USER message (i.e., the assistant responded).
    for (let i = userMsgIndex + 1; i < sessionConversation.length; i++) {
      const m = sessionConversation[i];
      if (m?.type === "USER") return false;
      if (m?.type === "SYSTEM") return true;
    }
    return false;
  };

  const handleTypingComplete = (msgIndex) => {
    setSessionConversation((prev) => {
      const message = prev[msgIndex];
      if (message?.showCharts || !hasDisplayableCharts(message?.charts)) {
        return prev;
      }
      const updated = prev.map((m, i) =>
        i === msgIndex ? { ...m, showCharts: true } : m
      );
      return updated;
    });
    setIsBotTyping(false);

    setTimeout(() => {
      if (textareaRef.current) {
        textareaRef.current.focus();
      }
    }, 100);
  };

  useEffect(() => {
    // Auto-scroll disabled - user can manually scroll to see responses
    // This prevents jarring scroll behavior when responses arrive
  }, [chatLoader, loadingPagination, isPaginationUpdate]);

  // Scroll to processing status when it appears
  useEffect(() => {
    if (processingStatus && processingWrapperRef.current) {
      setTimeout(() => {
        // Only keep the processing indicator in view if the user hasn't
        // intentionally scrolled up.
        if (!shouldAutoScrollRef.current) return;
        processingWrapperRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }, 100);
    }
  }, [processingStatus]);

  return (
    <>
      {newSession ? (
        <>
          {/* Professional Chat Header */}
          <div className="chat-header">
            <div className="chat-header-left">
              <button 
                className="sidebar-toggle-header"
                onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
                title={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
              >
                {isSidebarCollapsed ? (
                  <IconChevronRight width={20} height={20} />
                ) : (
                  <IconChevronLeft width={20} height={20} />
                )}
              </button>
              {isSidebarCollapsed && (
                <img 
                  src={emcureLogo} 
                  alt="Emcure" 
                  className="emcure-logo"
                />
              )}
              {isSidebarCollapsed && (
                <button 
                  onClick={() => {setNewSession(true);setActiveSessionId(null)}} 
                  className="new-session-btn-header"
                  title="New session"
                >
                  <IconPlus width={14} height={14} />
                  New Session
                </button>
              )}
              {isSidebarCollapsed && (
                <div className="session-dropdown">
                  <button 
                    className="session-dropdown-toggle"
                    onClick={() => setShowSessionDropdown(!showSessionDropdown)}
                  >
                    <span>{sessions.find(s => s.id === activeSessionId)?.sessionName || "Select Session"}</span>
                    <IconChevronDown width={16} height={16} />
                  </button>
                  {showSessionDropdown && (
                    <div className="session-dropdown-menu">
                      {sessions.map((session) => (
                        <button
                          key={session.id}
                          className={`session-dropdown-item ${activeSessionId === session.id ? 'active' : ''}`}
                          onClick={() => {
                            setActiveSessionId(session.id);
                            setNewSession(false);
                            setShowSessionDropdown(false);
                          }}
                        >
                          {session.sessionName}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              )}
              <div className="chat-header-info">
                <h3 className="chat-header-title hidden">AI Assistant</h3>
              </div>
            </div>
            <div className="chat-header-actions">
              {(hasAdminAccess || hasSupervisorAccess || hasSemanticAdminAccess) && <DashboardPanelSwitcher variant="chat" />}
              <div className="export-dropdown">
                <button 
                  className="header-action-btn btn-disabled" 
                  title="Export Chat" 
                  onClick={() => setShowExportMenu(!showExportMenu)}
                  disabled
                >
                  <IconDownload width={18} height={18} />
                </button>
              </div>
              
              <button 
                className="header-action-btn btn-disabled" 
                title="Clear Chat" 
                disabled
              >
                <IconTrash width={18} height={18} />
              </button>
              <button 
                className="header-action-btn logout-btn" 
                title="Logout" 
                onClick={() => setShowLogoutConfirm(true)}
              >
                <IconLogout width={18} height={18} />
              </button>
            </div>
          </div>

          <div className="professional-welcome">
            <div className="chat-landing-brand-header">
              <div className="chat-landing-brand-logo">
                <IconMessageBubbleWhite width={32} height={32} />
              </div>
              <h1 className="chat-landing-brand-title">Emcure AI Assistant</h1>
              <p className="chat-landing-brand-subtitle">
                Your intelligent companion for data insights and analytics
              </p>
            </div>

            <div className="quick-actions-wrapper">
              <div className="quick-actions quick-actions-row">
                <div className="action-card quick-action-card" onClick={() => setInputValue("Show me top 10 sales data")}>
                  <span className="action-icon">
                    <QuickBarChart width={24} height={24} />
                  </span>
                  <div className="action-title">Sales Analytics</div>
                  <div className="action-desc">View top performing sales records</div>
                </div>
                <div className="action-card quick-action-card" onClick={() => setInputValue("Show me the total budget for last year")}>
                  <span className="action-icon">
                    <QuickCurrency width={24} height={24} />
                  </span>
                  <div className="action-title">Budget Analytics</div>
                  <div className="action-desc">View total budget for last year</div>
                </div>
                <div className="action-card quick-action-card" onClick={() => setInputValue("Show me the top 10 HQs by achievement percentage")}>
                  <span className="action-icon">
                    <QuickStar width={24} height={24} />
                  </span>
                  <div className="action-title">Achievement</div>
                  <div className="action-desc">Top 10 HQs by achievement percentage</div>
                </div>
              </div>
            </div>

            <div className="professional-input-wrapper">
              <textarea
                ref={textareaRef}
                className="professional-textarea"
                placeholder="Ask me anything about your data..."
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey && !isBotTyping && !chatLoader) {
                    e.preventDefault();
                    handleSendMessage();
                  }
                }}
                disabled={isBotTyping || chatLoader}
              />
              <div className="input-footer">
                <span className="input-hint">Press Enter to send, Shift + Enter for new line</span>
                <div className="input-actions-row">
                  {/* Query Mode Dropdown */}
                  <div className="query-mode-wrapper" ref={queryModeDropdownRef}>
                    <button
                      className="query-mode-trigger"
                      onClick={(e) => { e.stopPropagation(); setShowQueryModeDropdown(p => !p); }}
                      title="Switch query mode"
                    >
                      {queryMode === 'qa'
                        ? <QuestionAnswerRoundedIcon style={{ fontSize: 16, color: '#B90005' }} />
                        : <TipsAndUpdatesRoundedIcon style={{ fontSize: 16, color: '#B90005' }} />}
                      <span>{queryMode === 'qa' ? 'Q/A' : 'Reasoning'}</span>
                      <IconChevronDownBold width={10} height={10} />
                    </button>
                    {showQueryModeDropdown && (
                      <div className="query-mode-dropdown">
                        <button
                          className={`query-mode-item${queryMode === 'qa' ? ' active' : ''}`}
                          onClick={() => { setQueryMode('qa'); setShowQueryModeDropdown(false); }}
                        >
                          <QuestionAnswerRoundedIcon style={{ fontSize: 16 }} />
                          <span>Q/A</span>
                        </button>
                        <button
                          className={`query-mode-item${queryMode === 'reasoning' ? ' active' : ''}`}
                          onClick={() => { setQueryMode('reasoning'); setShowQueryModeDropdown(false); }}
                        >
                          <TipsAndUpdatesRoundedIcon style={{ fontSize: 16 }} />
                          <span>Reasoning</span>
                        </button>
                      </div>
                    )}
                  </div>
                  <button
                    className="professional-send-btn"
                    onClick={handleSendMessage}
                    disabled={isBotTyping || chatLoader}
                  >
                    <IconSendWhite width={18} height={18} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="chat-container-wrapper">
          {/* Professional Chat Header */}
          <div className="chat-header">
            <div className="chat-header-left">
              <button 
                className="sidebar-toggle-header"
                onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
                title={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
              >
                {isSidebarCollapsed ? (
                  <IconChevronRight width={20} height={20} />
                ) : (
                  <IconChevronLeft width={20} height={20} />
                )}
              </button>
              {isSidebarCollapsed && (
                <img 
                  src={emcureLogo} 
                  alt="Emcure" 
                  className="emcure-logo-header"
                />
              )}
              {isSidebarCollapsed && (
                <button 
                  onClick={() => {setNewSession(true);setActiveSessionId(null)}} 
                  className="new-session-btn-header"
                  title="New session"
                >
                  <IconPlus width={14} height={14} />
                  New Session
                </button>
              )}
              {isSidebarCollapsed && (
                <div className="session-dropdown">
                  <button 
                    className="session-dropdown-toggle"
                    onClick={() => setShowSessionDropdown(!showSessionDropdown)}
                  >
                    <span>{sessions.find(s => s.id === activeSessionId)?.sessionName || "Select Session"}</span>
                    <IconChevronDown width={16} height={16} />
                  </button>
                  {showSessionDropdown && (
                    <div className="session-dropdown-menu">
                      {sessions.map((session) => (
                        <button
                          key={session.id}
                          className={`session-dropdown-item ${activeSessionId === session.id ? 'active' : ''}`}
                          onClick={() => {
                            setActiveSessionId(session.id);
                            setNewSession(false);
                            setShowSessionDropdown(false);
                          }}
                        >
                          {session.sessionName}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              )}
              <div className="chat-header-info">
                <h3 className="chat-header-title hidden">AI Assistant</h3>
                {/* WebSocket Connection Status - Optional */}
                <div className={`ws-connection-status ${wsConnected ? 'ws-connected' : 'ws-disconnected'} ws-connection-status-hidden`}>
                  <span className="ws-status-dot"></span>
                  <span>{wsConnected ? 'Live (WebSocket)' : 'Offline (WebSocket)'}</span>
                </div>
              </div>
            </div>
            <div className="chat-header-actions">
              {(hasAdminAccess || hasSupervisorAccess || hasSemanticAdminAccess) && <DashboardPanelSwitcher variant="chat" />}
              {/* Back to Admin indicator – only shown when user arrived from admin panel */}
              <div className="export-dropdown">
                
                <button 
                  className="header-action-btn" 
                  title="Export Chat" 
                  onClick={() => setShowExportMenu(!showExportMenu)}
                >
                  <IconDownload width={18} height={18} />
                </button>
                {showExportMenu && (
                  <div className="export-menu">
                    <button className="export-menu-item" onClick={handleDownloadExcel}>
                      <IconDocumentExcel width={16} height={16} />
                      Export as Excel
                    </button>
                    <button className="export-menu-item" onClick={handleDownloadDOCX}>
                      <IconDocumentWord width={16} height={16} />
                      Export as Word
                    </button>
                    <button className="export-menu-item" onClick={handleDownloadPDF}>
                      <IconDocumentPdf width={16} height={16} />
                      Export as PDF
                    </button>
                  </div>
                )}
              </div>
              <button 
                className="header-action-btn" 
                title="Clear Chat" 
                onClick={() => setShowDeleteConfirm(true)}
                disabled={!activeSessionId}
              >
                <IconTrash width={18} height={18} />
              </button>
              <button 
                className="header-action-btn logout-btn" 
                title="Logout" 
                onClick={() => setShowLogoutConfirm(true)}
              >
                <IconLogout width={18} height={18} />
              </button>
            </div>
          </div>

          <div
            className="chat-section"
            ref={chatSectionRef}
          >
            {/* History Loading Indicator */}
            {isLoadingHistory && (
              <div className="history-loader-overlay">
                <div className="history-loader-content">
                  <div className="history-loader-spinner"></div>
                  <p className="history-loader-text">Loading chat history...</p>
                </div>
              </div>
            )}
            {sessionConversation.map((msg, idx) => (
                <div
                  key={msg.id || idx}
                  className={`chat-bubble ${msg.type === "USER" ? "user" : "bot"}${msg.isReasoning ? ' reasoning' : ''}${
                    msg.type === "SYSTEM" &&
                    ((msg.rawResults && msg.rawResults.length > 0) ||
                      hasDisplayableCharts(msg.charts) ||
                      (suggestionsForMessage === idx &&
                        (loadingSuggestions || suggestions.length > 0)))
                      ? " has-wide-content"
                      : ""
                  }`}
                >
                  <div>
                    <img
                      src={msg.type === "USER" ? iconProfile : ""}
                      alt="icon"
                    />
                  </div>
                  <div className="chat-bubble-content-wrapper">
                    {msg.type === "SYSTEM" ? (
                      <>
                        {/* NEW: Sub-query dropdown for reasoning mode */}
                        {(msg.isReasoning || msg.queryType === 'reasoning') && msg.subQueries && msg.subQueries.length > 0 && (
                          <div className="sub-query-dropdown-container">
                            <div className="sub-query-label">Analysis Breakdown:</div>
                            <div className="sub-query-dropdown-wrapper">
                              <button
                                type="button"
                                className="sub-query-dropdown-btn selected"
                                onClick={() => setShowSubQueryDropdown(prev => ({
                                  ...prev,
                                  [idx]: !prev[idx]
                                }))}
                              >
                                <div className="selected-sub-query">
                                  <span className="sub-query-badge generic">FA</span>
                                  <span className="sub-query-text-label">Full Analysis Breakdown</span>
                                </div>
                                <IconChevronDown width={12} height={12} />
                              </button>
                              {showSubQueryDropdown[idx] && (
                                <div className="sub-query-dropdown-menu">
                                  {msg.subQueries.map((subQuery) => (
                                    <div
                                      key={subQuery.index}
                                      className="sub-query-dropdown-item sub-query-dropdown-item-static"
                                    >
                                      <span className="sub-query-number">Q{subQuery.index}</span>
                                      <span className="sub-query-text">{subQuery.question}</span>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        <div
                          className={`bot-message-stack${
                            (hasDisplayableCharts(msg.charts) && !shouldRenderDataTable(msg)) ||
                            (suggestionsForMessage === idx &&
                              (loadingSuggestions || suggestions.length > 0))
                              ? " has-wide-content"
                              : ""
                          }`}
                        >
                        {msg.fromHistory ? (
                          <>
                            <div className="bot-bubble-with-badge">
                              {msg.queryType && (
                                <div className="bot-query-mode-badge-row">
                                  <span className={`query-mode-indicator ${msg.queryType.toLowerCase()}`}>
                                    {msg.queryType.toLowerCase() === 'reasoning' ? (
                                      <>
                                        <TipsAndUpdatesRoundedIcon style={{ fontSize: 12, marginRight: 4 }} />
                                        Reasoning
                                      </>
                                    ) : (
                                      <>
                                        <QuestionAnswerRoundedIcon style={{ fontSize: 12, marginRight: 4 }} />
                                        Q/A
                                      </>
                                    )}
                                  </span>
                                </div>
                              )}
                              <div
                                className="bot-message-content"
                                title={safeBotDisplayText(
                                  msg.rawResults && msg.rawResults.length > 0
                                    ? removeMarkdownTable(msg.body)
                                    : msg.body
                                ).replace(/<br\s*\/?>/gi, "\n")}
                              >
                                <MarkdownRenderer 
                                  content={safeBotDisplayText(
                                    msg.rawResults && msg.rawResults.length > 0 
                                      ? removeMarkdownTable(msg.body) 
                                      : msg.body
                                  ).replace(/<br\s*\/?>/gi, '\n')}
                                  isBot={true}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="bot-bubble-with-badge">
                              {msg.queryType && (
                                <div className="bot-query-mode-badge-row">
                                  <span className={`query-mode-indicator ${msg.queryType.toLowerCase()}`}>
                                    {msg.queryType.toLowerCase() === 'reasoning' ? (
                                      <>
                                        <TipsAndUpdatesRoundedIcon style={{ fontSize: 12, marginRight: 4 }} />
                                        Reasoning
                                      </>
                                    ) : (
                                      <>
                                        <QuestionAnswerRoundedIcon style={{ fontSize: 12, marginRight: 4 }} />
                                        Q/A
                                      </>
                                    )}
                                  </span>
                                </div>
                              )}
                              <div
                                className="bot-message-content"
                                title={safeBotDisplayText(
                                  msg.rawResults && msg.rawResults.length > 0
                                    ? removeMarkdownTable(msg.body)
                                    : msg.body
                                ).replace(/<br\s*\/?>/gi, "\n")}
                              >
                                <MarkdownRenderer
                                  content={safeBotDisplayText(
                                    msg.rawResults && msg.rawResults.length > 0
                                      ? removeMarkdownTable(msg.body)
                                      : msg.body
                                  ).replace(/<br\s*\/?>/gi, "\n")}
                                  isBot={true}
                                />
                              </div>
                            </div>
                          </>
                        )}

                        {shouldRenderDataTable(msg) &&
                          renderDataTable(msg.rawResults, idx, msg.sqlQuery)}

                        {/* Charts (messages without a data table — table uses Table/Chart view switcher) */}
                        {shouldShowMessageCharts(msg) && !shouldRenderDataTable(msg) && (
                          <div
                            className="charts-wrapper charts-wrapper-flex"
                          >
                            {msg.charts.map((chart, cIdx) => {
                              const chartKey = `${idx}-${cIdx}`;
                              const chartTypeRaw = String(chart.type || chart.chart_type || "").toLowerCase();

                              const validData = Array.isArray(chart.data)
                                ? chart.data.filter((d) =>
                                    isChartPointValid(d, chart, chartTypeRaw)
                                  )
                                : [];

                              const chartType = resolveChatChartType(
                                chart,
                                chartTypeOverrides[chartKey],
                                validData.length
                              );

                              if (validData.length === 0) {
                                return (
                                  <div
                                    key={cIdx}
                                    className="chart-error-container"
                                  >
                                    <p className="chart-error-text">
                                      No valid data available for this chart
                                    </p>
                                  </div>
                                );
                              }



                              return (
                                <div
                                  key={`chart-${idx}-${cIdx}-${chart.type}`}
                                  className="chart-item-wrapper-styled"
                                  ref={chart.ref}
                                >
                                  {/* Chart Header */}
                                  <div className="chart-header">
                                    <h3 className="chart-title">
                                      {safeText(chart.title) || 'Chart'}
                                    </h3>
                                    <div className="chart-header-actions">
                                      {/* Chart Type Dropdown */}
                                      <div
                                        className="chart-type-dropdown-wrapper"
                                        style={{ position: 'relative' }}
                                      >
                                        <button
                                          className="chart-action-btn chart-type-toggle-btn"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setOpenChartTypeDropdown(prev => prev === chartKey ? null : chartKey);
                                          }}
                                          title="Change chart type"
                                        >
                                          {/* Current type icon */}
                                          {chartType === 'pie' && (
                                            <IconChartPie width={14} height={14} />
                                          )}
                                          {chartType === 'bar' && (
                                            <IconChartBar width={14} height={14} />
                                          )}
                                          {chartType === 'line' && (
                                            <IconChartLine width={14} height={14} />
                                          )}
                                          <span style={{ textTransform: 'capitalize' }}>{chartType}</span>
                                          <IconChevronDownBold width={10} height={10} />
                                        </button>
                                        {openChartTypeDropdown === chartKey && (
                                          <div
                                            className="chart-type-dropdown-menu"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            {getChartTypeOptionsForPointCount(validData.length).map(
                                              ({ type: t, label }) => {
                                              const icon =
                                                t === "pie" ? (
                                                  <IconChartPie width={14} height={14} />
                                                ) : t === "line" ? (
                                                  <IconChartLine width={14} height={14} />
                                                ) : (
                                                  <IconChartBar width={14} height={14} />
                                                );
                                              return (
                                              <button
                                                key={t}
                                                type="button"
                                                className={`chart-type-dropdown-item${chartType === t ? ' active' : ''}`}
                                                onClick={() => {
                                                  setChartTypeOverrides(prev => ({ ...prev, [chartKey]: t }));
                                                  setOpenChartTypeDropdown(null);
                                                }}
                                              >
                                                {icon}
                                                {label}
                                              </button>
                                            );
                                            })}
                                          </div>
                                        )}
                                      </div>

                                      <button
                                        onClick={() => setFullViewChart({ ...chart, _selectedType: chartType })}
                                        className="chart-action-btn"
                                      >
                                        <IconExternalExpand width={14} height={14} />
                                        Full View
                                      </button>
                                      <button
                                        onClick={() =>
                                          handleExportPDF(
                                            chart.ref,
                                            chart.title.replace(/\s+/g, "_")
                                          )
                                        }
                                        className="chart-export-btn"
                                      >
                                        <IconDownload width={14} height={14} />
                                        Export PDF
                                      </button>
                                    </div>
                                  </div>

                                  <EmcureBubbleChartPlot
                                    chartType={chartType}
                                    validData={validData}
                                    chart={chart}
                                    cIdx={cIdx}
                                    gradIdPrefix={`${idx}-${cIdx}`}
                                    formatDateAxis={formatDateValue}
                                    parseTooltipNumber={parseTooltipMetricValue}
                                  />
                                  <ChartPdfExportTable chart={{ ...chart, data: validData }} />
                                </div>
                              );
                            })}
                          </div>
                        )}

                        {msg.sqlQuery && safeText(msg.sqlQuery) && (
                          <details
                            className="sql-query-details sql-details-wrapper"
                          >
                            <summary
                              className="sql-summary-styled"
                            >
                              <div className="sql-query-header">
                                <div className="sql-query-icon">
                                  <IconSqlBracketsWhite width={16} height={16} />
                                </div>
                                <div className="sql-query-info">
                                  <div className="sql-query-label">
                                    Generated SQL Query
                                  </div>
                                  <div className="sql-query-hint">
                                    Click to expand and view the query
                                  </div>
                                </div>
                              </div>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleCopySQL(msg.sqlQuery, idx);
                                }}
                                className="btn-copy-sql-styled"
                              >
                                {copiedIndex === idx ? (
                                  <>
                                    <IconCheck width={14} height={14} />
                                    Copied!
                                  </>
                                ) : (
                                  <>
                                    <IconCopy width={14} height={14} />
                                    Copy
                                  </>
                                )}
                              </button>
                            </summary>
                            <div className="sql-code-wrapper">
                              <pre
                                className="sql-code-pre"
                                dangerouslySetInnerHTML={{
                                  __html: highlightSql(msg.sqlQuery),
                                }}
                              />
                            </div>
                          </details>
                        )}

                        {/* Timestamp for Bot Messages - Above Feedback */}
                        {msg.type === "SYSTEM" && (
                          <div className="bot-message-footer">
                            <span className="time timestamp-bot">
                              <span className="color-000000">
                                Bot:{" "}
                              </span>
                              <span>{msg.time}</span>
                            </span>
                          </div>
                        )}

                        {/* Feedback Icons for Bot Messages */}
                        <div className="message-feedback">
                          <button
                            className={`feedback-btn ${feedbackState[idx] === 'up' ? 'active' : ''}`}
                            onClick={() => handleFeedback(idx, feedbackState[idx] === 'up' ? null : 'up')}
                            title="Good response"
                          >
                            {feedbackState[idx] === 'up' ? (
                              <IconThumbUpFilled width={16} height={16} />
                            ) : (
                              <IconThumbUpOutline width={16} height={16} />
                            )}
                          </button>
                          <button
                            className={`feedback-btn ${feedbackState[idx] === 'down' ? 'active' : ''}`}
                            onClick={() => handleFeedback(idx, feedbackState[idx] === 'down' ? null : 'down')}
                            title="Bad response"
                          >
                            {feedbackState[idx] === 'down' ? (
                              <IconThumbDownFilled width={16} height={16} />
                            ) : (
                              <IconThumbDownOutline width={16} height={16} />
                            )}
                          </button>
                        </div>

                        {/* Suggestions for this message */}
                        {suggestionsForMessage === idx && (loadingSuggestions || suggestions.length > 0) && (
                          <div className="bot-suggestions">
                            {loadingSuggestions ? (
                              <div className="bot-suggestions-loading">
                                <div className="bot-suggestions-spinner"></div>
                                <span>Loading suggestions...</span>
                              </div>
                            ) : (
                              <div className="bot-suggestions-list">
                                {suggestions.map((suggestion, sidx) => (
                                  <button
                                    key={sidx}
                                    className="bot-suggestion-item"
                                    onClick={() => {
                                      // Add typing animation for suggestion
                                      let index = 0;
                                      const typeSuggestion = () => {
                                        if (index < suggestion.length) {
                                          setInputValue(suggestion.substring(0, index + 1));
                                          index++;
                                          setTimeout(typeSuggestion, 30); // 30ms delay between characters
                                        }
                                      };
                                      
                                      // Start typing animation
                                      typeSuggestion();
                                      
                                      // Clear suggestions
                                      setSuggestions([]);
                                      setSuggestionsForMessage(null);
                                      
                                      // Focus textarea after a short delay
                                      setTimeout(() => {
                                        if (textareaRef.current) {
                                          textareaRef.current.focus();
                                          textareaRef.current.setSelectionRange(suggestion.length, suggestion.length);
                                        }
                                      }, 50);
                                    }}
                                  >
                                    <IconChevronRightSm width={12} height={12} />
                                    {suggestion}
                                  </button>
                                ))}
                              </div>
                            )}
                          </div>
                        )}

                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className="user-bubble-row"
                          onMouseEnter={() => setHoveredUserMessageId(msg.id)}
                          onMouseLeave={() => setHoveredUserMessageId(null)}
                        >
                          {/* Actions placed horizontally beside (before) the bubble, like the screenshot */}
                          {((hoveredUserMessageId === msg.id && isUserMessageResponseCompleted(idx)) || pausedUserMessageId === msg.id) &&
                            editingUserMessageId !== msg.id && (
                            <div className="user-bubble-actions-inline">
                              <button
                                className="user-bubble-action-icon-btn"
                                onClick={() => handleCopyUserMessage(msg)}
                                title={copiedUserMessageId === msg.id ? 'Copied' : 'Copy'}
                                aria-label="Copy message"
                              >
                                <IconCopy width={12} height={12} />
                              </button>
                              <button
                                className="user-bubble-action-icon-btn"
                                onClick={() => handleStartEditUserMessage(msg)}
                                title="Edit"
                                aria-label="Edit message"
                              >
                                <IconPencilEdit width={12} height={12} />
                              </button>
                            </div>
                          )}

                          <div className="user-bubble-with-timestamp">
                            <div className={`user-message-content${editingUserMessageId === msg.id ? ' editing' : ''}`}>
                              {editingUserMessageId === msg.id ? (
                                <div className="user-inline-editor">
                                  <textarea
                                    className="user-inline-editor-textarea"
                                    value={editingText}
                                    onChange={(e) => setEditingText(e.target.value)}
                                    rows={3}
                                    autoFocus
                                  />
                                  <div className="user-inline-editor-actions">
                                    <button
                                      className="user-inline-icon-btn send"
                                      title="Send edited message"
                                      onClick={handleSendEditedUserMessage}
                                    >
                                      <IconSend width={16} height={16} />
                                    </button>
                                    <button
                                      className="user-inline-icon-btn cancel"
                                      title="Cancel edit"
                                      onClick={handleCancelEditUserMessage}
                                    >
                                      <IconX width={16} height={16} />
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <MarkdownRenderer content={safeText(msg.body).replace(/<br\s*\/?>/gi, '\n')} isBot={false} />
                              )}
                            </div>
                            {/* Timestamp for user messages: below the bubble, aligned with the bubble right edge */}
                            <span className="time timestamp-user">
                              <span className="color-000000">
                                {userName}:{" "}
                              </span>
                              <span>{msg.time}</span>
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                    
                  </div>
                </div>
              ))}

            {chatLoader && (
              <div className="chat-bubble bot">
                {/* <div>
                  <img src={iconChatBot} alt="bot" />
                </div> */}
                <div className="processing-wrapper" ref={processingWrapperRef}>
                  {processingStatus && (
                    <div className="ws-status-text-content">
                      <div className="ws-status-text-wrapper">
                        <span className="ws-status-text">{processingStatus}</span>
                        {/* NEW: Show concurrent request count */}
                        {Object.keys(inFlightRequests).length > 1 && (
                          <span className="concurrent-requests-count">
                            ({Object.keys(inFlightRequests).length} queries processing)
                          </span>
                        )}
                        <div className="ws-status-dots">
                          <span className="ws-dot"></span>
                          <span className="ws-dot"></span>
                          <span className="ws-dot"></span>
                        </div>
                      </div>

                      {/* NEW: Show Analysis Breakdown during loading if available */}
                      {queryMode === 'reasoning' && Object.values(inFlightRequests).some(req => req.subQueries && req.subQueries.length > 0) && (
                        <div className="loading-analysis-breakdown">
                          {Object.values(inFlightRequests)
                            .filter(req => req.subQueries && req.subQueries.length > 0)
                            .map((req, ridx) => (
                              <div key={ridx} className="sub-query-dropdown-container">
                                <div className="sub-query-label">Analysis Breakdown:</div>
                                <div className="sub-query-dropdown-wrapper">
                                  <button className="sub-query-dropdown-btn selected" disabled>
                                    <div className="selected-sub-query">
                                      <span className="sub-query-badge">{req.subQueries.length}</span>
                                      <span className="sub-query-text-label">Analysis Steps Identified</span>
                                    </div>
                                    <IconChevronDown width={12} height={12} />
                                  </button>
                                </div>
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Floating scroll arrows – only one shows at a time */}
          {(showScrollUp || showScrollDown) && (
            <div className="chat-scroll-arrows">
              {/* ↑ Up arrow: visible when scrolled down → click to go to TOP */}
              {showScrollUp && (
                <button
                  className="chat-scroll-arrow visible"
                  onClick={() =>
                    chatSectionRef.current?.scrollTo({ top: 0, behavior: 'smooth' })
                  }
                  title="Scroll to top"
                  aria-label="Scroll to top"
                >
                  <IconScrollUp width={18} height={18} />
                </button>
              )}
              {/* ↓ Down arrow: visible when at top → click to go to BOTTOM */}
              {showScrollDown && (
                <button
                  className="chat-scroll-arrow visible"
                  onClick={() => {
                    const el = chatSectionRef.current;
                    if (el) el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
                  }}
                  title="Scroll to bottom"
                  aria-label="Scroll to bottom"
                >
                  <IconScrollDown width={18} height={18} />
                </button>
              )}
            </div>
          )}

          {/* Top Used Queries Accordion */}
          <div className="top-queries-section">
            <button 
              className="top-queries-toggle"
              onClick={() => setShowTopQueries(!showTopQueries)}
            >
              <IconChevronRight width={12} height={12} />
              <span>Top Used Queries</span>
              <IconChevronRightXs
                width={16}
                height={16}
                className={`top-queries-toggle-icon ${showTopQueries ? 'rotated' : ''}`}
              />
            </button>
            
            {showTopQueries && (
              <div className="top-queries-list">
                {loadingTopQueries ? (
                  <div className="top-queries-loading">
                    Loading top queries...
                  </div>
                ) : topQueries.length > 0 ? (
                  topQueries.map((query, idx) => (
                    <button
                      key={idx}
                      className="top-query-item"
                      onClick={() => handleQuerySelect(query)}
                    >
                      <IconSearch width={14} height={14} />
                      {query}
                    </button>
                  ))
                ) : (
                  <div className="top-queries-empty">
                    No top queries available
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Input */}
          <div className="query-input">
            <div className="professional-input-wrapper">
              <textarea
                ref={textareaRef}
                className="professional-textarea"
                placeholder="Ask me anything about your data..."
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey && !isBotTyping && !chatLoader) {
                    e.preventDefault();
                    handleSendMessage();
                  }
                }}
                disabled={isBotTyping || chatLoader}
              />
              <div className="input-footer">
                <span className="input-hint">Press Enter to send, Shift + Enter for new line</span>
                <div className="input-actions-row">
                  <div className="query-mode-wrapper" ref={queryModeDropdownRef}>
                    <button
                      className="query-mode-trigger"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowQueryModeDropdown((p) => !p);
                      }}
                      title="Switch query mode"
                    >
                      {queryMode === "qa" ? (
                        <QuestionAnswerRoundedIcon style={{ fontSize: 16, color: "#B90005" }} />
                      ) : (
                        <TipsAndUpdatesRoundedIcon style={{ fontSize: 16, color: "#B90005" }} />
                      )}
                      <span>{queryMode === "qa" ? "Q/A" : "Reasoning"}</span>
                      <IconChevronDownBold width={10} height={10} />
                    </button>
                    {showQueryModeDropdown && (
                      <div className="query-mode-dropdown query-mode-dropdown-up">
                        <button
                          className={`query-mode-item${queryMode === "qa" ? " active" : ""}`}
                          onClick={() => {
                            setQueryMode("qa");
                            setShowQueryModeDropdown(false);
                          }}
                        >
                          <QuestionAnswerRoundedIcon style={{ fontSize: 16 }} />
                          <span>Q/A</span>
                        </button>
                        <button
                          className={`query-mode-item${queryMode === "reasoning" ? " active" : ""}`}
                          onClick={() => {
                            setQueryMode("reasoning");
                            setShowQueryModeDropdown(false);
                          }}
                        >
                          <TipsAndUpdatesRoundedIcon style={{ fontSize: 16 }} />
                          <span>Reasoning</span>
                        </button>
                      </div>
                    )}
                  </div>

                  {isBotTyping || chatLoader ? (
                    <button
                      className="professional-pause-btn"
                      onClick={handlePauseResponse}
                      title="Pause response"
                      aria-label="Pause response"
                    >
                      <IconPauseSquare width={18} height={18} />
                    </button>
                  ) : (
                    <button
                      className="professional-send-btn"
                      onClick={handleSendMessage}
                      disabled={isBotTyping || chatLoader}
                    >
                      <IconSendWhite width={18} height={18} />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div 
          className="logout-modal-overlay"
          onClick={() => setShowLogoutConfirm(false)}
        >
          <div
            className="logout-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="logout-modal-header">
              <h5>Confirm Logout</h5>
              <button
                className="logout-modal-close"
                onClick={() => setShowLogoutConfirm(false)}
              >
                ×
              </button>
            </div>
            <div className="logout-modal-body">
              Are you sure you want to logout? You will need to sign in again to access the application.
            </div>
            <div className="logout-modal-footer">
              <button
                className="logout-modal-cancel"
                onClick={() => setShowLogoutConfirm(false)}
              >
                Cancel
              </button>
              <button 
                className="logout-modal-confirm"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Session Confirmation Modal */}
      {showDeleteConfirm && (
        <div 
          className="logout-modal-overlay"
          onClick={() => setShowDeleteConfirm(false)}
        >
          <div
            className="logout-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="logout-modal-header">
              <h5>Delete Chat Session</h5>
              <button
                className="logout-modal-close"
                onClick={() => setShowDeleteConfirm(false)}
              >
                ×
              </button>
            </div>
            <div className="logout-modal-body">
              Are you sure you want to delete this chat session? This action cannot be undone and all messages will be permanently deleted.
            </div>
            <div className="logout-modal-footer">
              <button
                className="logout-modal-cancel"
                onClick={() => setShowDeleteConfirm(false)}
              >
                Cancel
              </button>
              <button 
                className="logout-modal-confirm"
                onClick={handleDeleteSession}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Feedback Modal */}
      {showFeedbackModal && (
        <div 
          className="feedback-modal-overlay"
          onClick={() => {
            setShowFeedbackModal(false);
            setFeedbackMessageIndex(null);
            setFeedbackText('');
          }}
        >
          <div
            className="feedback-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="feedback-modal-header">
              <div className="feedback-modal-title-section">
                <div className="feedback-modal-icon">
                  <IconThumbDownFilled width={20} height={20} />
                </div>
                <div>
                  <h5>Provide Feedback</h5>
                  <p className="feedback-modal-subtitle">Help us improve by sharing what went wrong</p>
                </div>
              </div>
              <button
                className="feedback-modal-close"
                onClick={() => {
                  setShowFeedbackModal(false);
                  setFeedbackMessageIndex(null);
                  setFeedbackText('');
                }}
              >
                ×
              </button>
            </div>
            <div className="feedback-modal-body">
              <div className="feedback-text-section">
                <label className="feedback-label">
                  Please tell us what went wrong
                  <span className="feedback-char-count">{feedbackText.length}/500</span>
                </label>
                <textarea
                  className="feedback-textarea"
                  placeholder="Share your feedback to help us improve..."
                  value={feedbackText}
                  onChange={(e) => {
                    if (e.target.value.length <= 500) {
                      setFeedbackText(e.target.value);
                    }
                  }}
                  rows="6"
                  autoFocus
                />
              </div>
            </div>
            <div className="feedback-modal-footer">
              <button
                className="feedback-modal-cancel"
                onClick={() => {
                  setShowFeedbackModal(false);
                  setFeedbackMessageIndex(null);
                  setFeedbackText('');
                }}
              >
                Cancel
              </button>
              <button 
                className="feedback-modal-submit"
                onClick={handleSubmitFeedback}
              >
                <IconCheck width={16} height={16} />
                Submit Feedback
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Full View Chart Modal */}
      {fullViewChart && (() => {
        const fullViewPointCount = Array.isArray(fullViewChart.data)
          ? fullViewChart.data.length
          : 0;
        const fullViewChartType = resolveChatChartType(
          fullViewChart,
          fullViewChart._selectedType,
          fullViewPointCount
        );
        return (
        <EmcureModalShell
          onClose={() => setFullViewChart(null)}
          title={fullViewChart.title || "Chart"}
          headerExtra={
            <div className="chart-type-dropdown-wrapper" style={{ position: "relative" }}>
              <button
                type="button"
                className="chart-action-btn chart-type-toggle-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenChartTypeDropdown((prev) => (prev === "modal" ? null : "modal"));
                }}
                title="Change chart type"
              >
                {fullViewChartType === "pie" && (
                  <IconChartPie width={14} height={14} />
                )}
                {fullViewChartType === "bar" && (
                  <IconChartBar width={14} height={14} />
                )}
                {fullViewChartType === "line" && (
                  <IconChartLine width={14} height={14} />
                )}
                <span style={{ textTransform: "capitalize" }}>
                  {fullViewChartType}
                </span>
                <IconChevronDownBold width={10} height={10} />
              </button>
              {openChartTypeDropdown === "modal" && (
                <div className="chart-type-dropdown-menu" onClick={(e) => e.stopPropagation()}>
                  {getChartTypeOptionsForPointCount(fullViewPointCount).map(
                    ({ type: t, label }) => {
                      const icon =
                        t === "pie" ? (
                          <IconChartPie width={14} height={14} />
                        ) : t === "line" ? (
                          <IconChartLine width={14} height={14} />
                        ) : (
                          <IconChartBar width={14} height={14} />
                        );
                      return (
                    <button
                      type="button"
                      key={t}
                      className={`chart-type-dropdown-item${
                        fullViewChartType === t ? " active" : ""
                      }`}
                      onClick={() => {
                        setFullViewChart((prev) => ({ ...prev, _selectedType: t }));
                        setOpenChartTypeDropdown(null);
                      }}
                    >
                      {icon}
                      {label}
                    </button>
                      );
                    }
                  )}
                </div>
              )}
            </div>
          }
        >
            <div className="chart-modal-body">
              <EmcureModalChartBody
                chart={fullViewChart}
                effectiveType={fullViewChartType}
                idPrefix="chat-fullview"
                formatDateAxis={formatDateValue}
                parseTooltipNumber={parseTooltipMetricValue}
              />
            </div>
        </EmcureModalShell>
        );
      })()}

      <SqlResultDataTableFullViewModal
        open={fullViewTable}
        onClose={() => setFullViewTable(null)}
        variant="chat"
        formatScalarForDisplay={safeText}
        chat={(() => {
          const fvIdx = parseTableMessageIndex(fullViewTable?.tableKey);
          const fvMsg =
            fullViewTable && !Number.isNaN(fvIdx) ? sessionConversation[fvIdx] : null;
          const fvFooter = fullViewTable
            ? resolveTableFooterState({
                rawResults: fullViewTable.data ?? [],
                dataSummary: fvMsg?.dataSummary ?? {},
                paginationInfo: fvMsg?.pagination ?? {},
                storedTotalCount: fullViewTable.totalCount ?? fvMsg?.totalCount,
                rawResultsBuffer: fvMsg?.rawResultsBuffer,
              })
            : null;
          return {
          getCsvExportOptions,
          onPickExportOption: (exportType) =>
            handleExportCSV({
              msgIndex: null,
              exportType,
              messageId: fullViewTable?.messageId,
              sessionId: fullViewTable?.sessionId,
            }),
          isExportMenuOpen: openTableExportDropdown === "fullview",
          onToggleExportMenu: () => {
            setOpenTableExportDropdown(openTableExportDropdown === "fullview" ? null : "fullview");
          },
          isExportOptionLoading: (exportType) => exportCsvLoadingKey === `fullview:${exportType}`,
          messageId: fullViewTable?.messageId,
          sessionId: fullViewTable?.sessionId,
          showLoadMore: Boolean(fullViewTable?.sqlQuery && fvFooter?.hasMore),
          loadMoreLoading: fullViewTableLoading,
          onLoadMore: handleFullViewTableLoadMore,
          totalCount: fvFooter?.totalCount ?? fullViewTable?.totalCount,
          loadMoreCount: fvFooter?.loadMoreCount,
          sort: buildTableSortProps(
            "fullview",
            fvIdx,
            fullViewTable?.messageId,
            fullViewTable?.sessionId,
            {
              queryRowCount: fvFooter?.totalCount ?? fullViewTable?.totalCount,
              loadedCount: fullViewTable?.data?.length ?? 0,
            }
          ),
          };
        })()}
      />
    </>
  );
};

export default ChatSection;
